/* Options:
Date: 2026-06-19 11:23:47
Version: 8.30
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44382

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
ExcludeTypes: GetInstitutionPersonnelEmailAddresses,InstitutionPersonnelEmailAddressesResponse,GetUserPersonnelEmailAddress,UserPersonnelEmailAddressResponse,SendRegistrationEmail,SendRandomisationEmail
//DefaultImports: 
*/

// @ts-nocheck

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IDelete
{
}

export class OrderForm
{
    public id?: number;
    public orderFormName: string;

    public constructor(init?: Partial<OrderForm>) { (Object as any).assign(this, init); }
}

export class Depot
{
    public id?: number;
    public depotName: string;
    public address: string;
    public email: string;
    public contactName: string;
    public phoneNo: string;
    public orderFormId: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public orderForm: OrderForm;

    public constructor(init?: Partial<Depot>) { (Object as any).assign(this, init); }
}

export class DrugType
{
    public id?: number;
    public name: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;

    public constructor(init?: Partial<DrugType>) { (Object as any).assign(this, init); }
}

export class Drug
{
    public id?: number;
    public drugName: string;
    public unitsPerShippingContainer: number;
    public containerName: string;
    public unitConcentration: number;
    public unitVolume: number;
    public enableDrugShipmentGeneration: boolean;
    public drugTypeId?: number;
    public drugType: DrugType;

    public constructor(init?: Partial<Drug>) { (Object as any).assign(this, init); }
}

export class Batch
{
    public id?: number;
    public drugId?: number;
    public batchNo: string;
    public dateExpiration?: string;
    public allocationCutOffDate?: string;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<Batch>) { (Object as any).assign(this, init); }
}

export class DepotBatch
{
    public id?: number;
    public depotId: number;
    public batchId: number;
    public depotBatchNo?: number;
    public drugUnitsTotal: number;
    public drugUnitsAllocated: number;
    public drugUnitsDestroyed: number;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public batch: Batch;

    public constructor(init?: Partial<DepotBatch>) { (Object as any).assign(this, init); }
}

export class DepotDrugUnits
{
    public depot: Depot;
    public drug: Drug;
    public drugUnits?: number;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<DepotDrugUnits>) { (Object as any).assign(this, init); }
}

export enum InvoiceStatus
{
    Pending = 1,
    Approved = 2,
    NotApproved = 3,
    Init = 4,
    Review = 5,
}

// @DataContract
export class FileUploadTemporary implements IFileUploadTemporary
{
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public extension: string;

    // @DataMember(Order=4)
    public fileSize?: number;

    // @DataMember(Order=5)
    public contentType: string;

    // @DataMember(Order=6)
    public image: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class InvoiceFile implements IDataModel
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.InvoiceManagement.Models.Dos.Invoice)")
    public invoiceId?: number;

    // @Ignore()
    public exists?: boolean;

    // @Ignore()
    public image?: boolean;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public upload: FileUploadTemporary;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InvoiceFile>) { (Object as any).assign(this, init); }
}

export class Invoice implements IDataModel, IInvoiceManagementForm
{
    public id?: number;
    public patientId?: number;
    public typeId?: number;
    public typeOther: string;
    public visitId?: number;
    public invoiceSubmittedDate?: string;
    public invoiceDate?: string;
    public amount?: number;
    public status?: InvoiceStatus;
    public statusReason: string;
    public statusConfirmedBy: string;
    public statusConfirmedDate?: string;
    // @Ignore()
    public invoiceFile: InvoiceFile;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Invoice>) { (Object as any).assign(this, init); }
}

export interface IReportRequest
{
    token: string;
}

export enum PharmacyStatus
{
    Inactive = 1,
    Open = 2,
    Closed = 3,
}

export class PharmacyDrug
{
    public id?: number;
    public pharmacyId: number;
    public drugId: number;
    public capacity: number;
    public minThreshold: number;
    public enabled: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PharmacyDrug>) { (Object as any).assign(this, init); }
}

export class Pharmacy
{
    public id?: number;
    public depotId: number;
    public institutionCode: string;
    public pharmacyName: string;
    public phoneNumber: string;
    public address: string;
    public email: string;
    public ccOnEmails: boolean;
    public pharmacyStatus?: PharmacyStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public notes: string;
    public pharmacistPersonId?: number;
    public pharmacyDrugs: PharmacyDrug[];

    public constructor(init?: Partial<Pharmacy>) { (Object as any).assign(this, init); }
}

export enum DoseCalculationType
{
    Calculated = 1,
    Flat = 2,
}

export class TimepointDrugTreatment
{
    public id?: number;
    public timepointId: number;
    public drugId: number;
    public treatmentId: number;
    public treatmentLevelId?: number;
    public doseCalculationType: DoseCalculationType;
    public postLastDispensationUnits: string;
    public postLastDispensationAmount?: number;
    public dose: number;
    public dispensationStartPoint: number;
    public expectedWithinUnits: string;
    public expectedWithinAmount?: number;
    public timepoint: Timepoint;
    public drug: Drug;

    public constructor(init?: Partial<TimepointDrugTreatment>) { (Object as any).assign(this, init); }
}

export class Timepoint
{
    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;
    public timepointDrugTreatments: TimepointDrugTreatment[];

    public constructor(init?: Partial<Timepoint>) { (Object as any).assign(this, init); }
}

export class DrugDispensation implements IDrugManagementForm
{
    public id?: number;
    public pharmacyId?: number;
    public patientId?: number;
    public drugId?: number;
    public externalDispensation?: boolean;
    public depotBatchId?: number;
    public timepointId?: number;
    public dateDispensation?: string;
    public drugUnits?: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;
    public pharmacy: Pharmacy;
    public depotBatch: DepotBatch;
    public timepoint: Timepoint;
    public comments: string;

    public constructor(init?: Partial<DrugDispensation>) { (Object as any).assign(this, init); }
}

export enum ShipmentStatus
{
    New = 1,
    Ordered = 2,
    InTransit = 3,
    Available = 4,
    Lost = 5,
    QuarantinedFromTransit = 6,
    Destroyed = 7,
    QuarantinedAtSite = 8,
}

export class DrugShipmentDepotBatch implements IDrugManagementForm
{
    public id?: number;
    public drugShipmentId?: number;
    public depotBatchId?: number;
    public drugUnits?: number;
    public drugUnitsUsed?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;
    public drugUnitsReturnedToDepot?: number;
    public drugUnitsTransportedToSite?: number;
    public notes: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;
    public depotBatch: DepotBatch;
    public drugAllocated?: number;
    public drugRemaining?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
}

export class DrugShipmentStatusHistory implements IDrugManagementForm
{
    public id?: number;
    public drugShipmentId?: number;
    public shipmentStatus: ShipmentStatus;
    public statusDate: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<DrugShipmentStatusHistory>) { (Object as any).assign(this, init); }
}

export class DrugManagementFileUploadTemporary implements IFileUploadTemporary
{
    public guid: string;
    public name: string;
    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public image: boolean;

    public constructor(init?: Partial<DrugManagementFileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class DrugManagementFile
{
    // @Ignore()
    public upload: DrugManagementFileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<DrugManagementFile>) { (Object as any).assign(this, init); }
}

export class DrugShipmentDocument
{
    public id?: number;
    public drugShipmentId?: number;
    public name: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public file: DrugManagementFile;

    public constructor(init?: Partial<DrugShipmentDocument>) { (Object as any).assign(this, init); }
}

export class DrugShipmentPharmacist
{
    public id?: number;
    public pharmacyId?: number;
    public pharmacistId?: number;
    public drugShipmentId?: number;

    public constructor(init?: Partial<DrugShipmentPharmacist>) { (Object as any).assign(this, init); }
}

export class DrugShipment implements IDrugManagementForm
{
    public id?: number;
    public institutionCode: string;
    public pharmacyId?: number;
    public pharmacyShipmentNo?: number;
    public shipmentStatus?: ShipmentStatus;
    public consignmentNo: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public notes: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];
    public drugShipmentStatusHistory: DrugShipmentStatusHistory[];
    public drugShipmentDocuments: DrugShipmentDocument[];
    public drugShipmentPharmacists: DrugShipmentPharmacist[];
    public validFrom?: string;
    public validTo?: string;

    public constructor(init?: Partial<DrugShipment>) { (Object as any).assign(this, init); }
}

export class DrugAmount
{
    public drugId?: number;
    public drugUnits?: number;

    public constructor(init?: Partial<DrugAmount>) { (Object as any).assign(this, init); }
}

export class DrugShipmentDepotBatchVerify
{
    public id?: number;
    public drugShipmentId?: number;
    public depotBatchId?: number;
    public drugUnits?: number;
    public drugUnitsReceived?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;
    public drugUnitsReturnedToDepot?: number;
    public drugUnitsTransportedToSite?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatchVerify>) { (Object as any).assign(this, init); }
}

export class DrugShipmentVerify
{
    public id?: number;
    public consignmentNo: string;
    public received?: string;
    public notes: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatchVerify[];
    public drugShipmentDocuments: DrugShipmentDocument[];

    public constructor(init?: Partial<DrugShipmentVerify>) { (Object as any).assign(this, init); }
}

export enum PatientTreatmentStatus
{
    OnTreatment = 1,
    OffTreatment = 2,
}

export class PatientDrug
{
    public id?: number;
    public patientId?: number;
    public drugId?: number;
    public patientTreatmentStatus?: PatientTreatmentStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PatientDrug>) { (Object as any).assign(this, init); }
}

export enum QuarantinedStockAction
{
    Quarantined = 1,
    ReturnStockToSiteSupply = 2,
    DestroyStock = 3,
}

// @DataContract
export class BatchAmount
{
    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public amount: number;

    public constructor(init?: Partial<BatchAmount>) { (Object as any).assign(this, init); }
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IEventDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IEventDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IEventDefinitionGetCollection extends IGet
{
}

export interface IFormDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IFormDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IFormDefinitionGetCollection extends IGet
{
}

export interface IPatientStateGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientStateGetCollection extends IGet
{
}

export interface ITreatmentGetSingleById extends IGet
{
    id?: number;
}

export interface ITreatmentGetCollection extends IGet
{
}

export interface IMasterGroupGetSingleById extends IGet
{
    id?: number;
}

export interface IMasterGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface IMasterGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetSingleById extends IGet
{
    id?: number;
}

export interface ICollaboratingGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface ICollaboratingGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICollaboratingGroupGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetSingleById extends IGet
{
    id?: number;
}

export interface ICountryGetSingleByCode extends IGet
{
    code: string;
}

export interface ICountryGetCollection extends IGet
{
}

export interface ICountryGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICountryGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
}

export interface ICountryGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
}

export interface IInstitutionGetSingleById extends IGet
{
    id?: number;
}

export interface IInstitutionGetSingleByCode extends IGet
{
    code: string;
}

export interface IInstitutionGetCollection extends IGet
{
}

export interface IInstitutionGetCollectionByCountryId extends IGet
{
    countryId?: number;
}

export interface IInstitutionGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCountryCode extends IGet
{
    countryCode: string;
}

export interface IInstitutionGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
}

export interface IInstitutionGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
}

export interface IPatientGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientGetSingleByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetValidationById extends IGet
{
    id?: number;
}

export interface IPatientGetValidationByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetCollection extends IGet
{
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryId extends IGet
{
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionId extends IGet
{
    institutionId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryCode extends IGet
{
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
    patientStateIds: number[];
}

export class Patient implements IPatient, IRegistrationPatient, IRandomisationPatient
{
    public id?: number;
    public patientStateId?: number;
    public studyNumber: string;
    public institutionId?: number;
    public institutionCode: string;
    public registrationNumber: string;
    public registrationDate?: string;
    public randomisationNumber: string;
    public randomisationDate?: string;
    public treatmentId?: number;
    public enteredBy?: string;
    public modifiedBy?: string;
    public enteredDate?: string;
    public modifiedDate?: string;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export interface IEventGetSingleById extends IGet
{
    id?: number;
}

export interface IEventGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetCollection extends IGet
{
}

export interface IEventGetCollectionByPatientId extends IGet
{
    patientId?: number;
}

export interface IEventGetCollectionByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
}

export class Event implements IEvent
{
    public id?: number;
    public patientId?: number;
    public eventDefinitionId?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Event>) { (Object as any).assign(this, init); }
}

export interface IFormGetSingleById extends IGet
{
    id?: number;
}

export interface IFormGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetCollection extends IGet
{
}

export interface IFormGetCollectionByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export interface IFormGetCollectionByCodes extends IGet
{
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
}

export class File
{
    public id?: number;
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public propertyName: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    // @Ignore()
    public upload: FileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export class SourceDocument implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public name: string;
    public fileTypeId?: number;
    public file: File;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SourceDocument>) { (Object as any).assign(this, init); }
}

export class FinanceMilestone implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public milestoneId?: number;
    public milestoneDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<FinanceMilestone>) { (Object as any).assign(this, init); }
}

export class Registration implements IForm
{
    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public patientIdentifier: string;
    public screeningDate?: string;
    public randomisationDate?: string;
    public plannedUseOfAbemaciclib?: number;
    public financeMilestones: FinanceMilestone[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Registration>) { (Object as any).assign(this, init); }
}

export interface IPatientGetEventStatesById extends IGet
{
    id?: number;
}

export interface IPatientGetEventStatesByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetFormStatesByIds extends IGet
{
    id?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
    PISignOffView = 43,
    PISignOffPerform = 44,
    PISignOffAdminister = 45,
    OpmsDataManage = 46,
    RedactVerificationAccess = 47,
    ReconsentAdminister = 48,
    TrialManagementAccess = 49,
    SourceDataVerificationAccess = 50,
    TrialParticipantAccess = 51,
    StaffTrainingAccess = 52,
    TrainingAccess = 53,
    ReportAccess = 54,
    WebsiteImporterAccess = 55,
    ConstituentManagerAccess = 56,
    OpmsBypassErrors = 57,
    RadiologyReviewAccess = 58,
    ApproveInvoice = 59,
    PrescreeningAccess = 60,
    PrescreeningAdminister = 61,
    InvoiceExportView = 62,
    InvoiceExportUpdate = 63,
    InvoiceRequisitionView = 64,
    InvoiceRequisitionUpdate = 65,
    CanCentralReview = 66,
    InvoiceView = 67,
    InvoiceUpdate = 68,
}

export class SentrySettings
{
    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class EmailAddress
{
    public displayName: string;
    public address: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export class ContactAddress
{
    public contactId?: number;
    public addressId?: number;
    public addressType?: number;
    public street: string;
    public city: string;
    public state: string;
    public postalCode: string;
    public countryOrRegion: string;
    public preferred?: number;

    public constructor(init?: Partial<ContactAddress>) { (Object as any).assign(this, init); }
}

export class ContactEmail
{
    public contactId?: number;
    public emailId?: number;
    public email: string;
    public preferred?: number;

    public constructor(init?: Partial<ContactEmail>) { (Object as any).assign(this, init); }
}

export class ContactPhone
{
    public contactId?: number;
    public phoneId?: number;
    public phoneNum: string;
    public phoneType?: number;
    public preferred?: number;

    public constructor(init?: Partial<ContactPhone>) { (Object as any).assign(this, init); }
}

export class Contact
{
    public id?: number;
    public title: string;
    public givenName: string;
    public middleName: string;
    public surname: string;
    public suffix: string;
    public jobTitle: string;
    public profession: string;
    public organisation: string;
    public businessHomePage: string;
    public postalAddressIndex?: number;
    public birthday?: string;
    public manager: string;
    public assistantName: string;
    public displayName: string;
    public fileAs: string;
    public notes: string;
    public department: string;
    public imAddress: string;
    public nickname: string;
    public officeLocation: string;
    public spouseName: string;
    public weddingAnniversary?: string;
    public outlookId: string;
    public outlookDateEntered?: string;
    public outlookDateModified?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public userEntered: string;
    public userModified: string;
    public inactive?: number;
    public preferred: string;
    public pronunciation: string;
    public maiden: string;
    public personalAssistant: string;
    public leaveNotes: string;
    public partTimeNotes: string;
    public pendingInactive?: number;
    public authorised?: boolean;
    public authorisedBy: string;
    public datePendingInactive?: string;
    public addresses: ContactAddress[];
    public emails: ContactEmail[];
    public phones: ContactPhone[];

    public constructor(init?: Partial<Contact>) { (Object as any).assign(this, init); }
}

export enum PatientStateType
{
    New = 1,
    RandomisedOnAbemaciclib = 2,
    RandomisedOffAbemaciclib = 3,
    RandomisedOnAbemaciclibNz = 4,
    Ineligible = 7,
    Waivered = 8,
    Removed = 9,
}

export enum LookupYesNoType
{
    No = 0,
    Yes = 1,
}

export enum LookupGenderType
{
    Female = 1,
    Male = 2,
    NonBinary = 3,
}

export enum LookupUntypedType
{
    NoType = 1,
}

export enum FormDefinitionType
{
    Registration = 1,
    FinanceMilestone = 2,
    SourceDocument = 3,
    ScreenFailure = 4,
}

export class AbemaReportRow
{
    public countryName?: string;
    public institutionName?: string;
    public fractionData?: string;
    public percentageData?: string;
    public colour?: number;

    public constructor(init?: Partial<AbemaReportRow>) { (Object as any).assign(this, init); }
}

export class DrugStockData
{
    public drugName: string;
    public batchNo: string;
    public dateExpiration?: string;
    public drugUnitsAvailable: number;

    public constructor(init?: Partial<DrugStockData>) { (Object as any).assign(this, init); }
}

export class DrugShipmentReport
{
    public institutionCode: string;
    public institutionName: string;
    public pharmacyAddress: string;
    public shipmentNumber: string;
    public eventDate: string;
    public user: string;
    public drugBatches: string;
    public abemaciclib150?: number;
    public abemaciclib100?: number;
    public abemaciclib50?: number;
    public status: string;

    public constructor(init?: Partial<DrugShipmentReport>) { (Object as any).assign(this, init); }
}

export class PatientAction
{
    public institutionCode: string;
    public institutionName: string;
    public randNo: string;
    public visit: string;
    public eventDate: string;
    public event: string;
    public user: string;
    public abemaciclibCn150?: number;
    public abemaciclibCn100?: number;
    public abemaciclibCn50?: number;
    public abemaciclibAu100?: number;
    public abemaciclibAu50?: number;
    public patientStatus: string;

    public constructor(init?: Partial<PatientAction>) { (Object as any).assign(this, init); }
}

export class BatchReport
{
    public batch: string;
    public drugName: string;
    public institution: string;
    public randNo: string;
    public visit: string;
    public dispensationDate: string;
    public drugs?: number;

    public constructor(init?: Partial<BatchReport>) { (Object as any).assign(this, init); }
}

export class DrugManagementLog
{
    public institutionName: string;
    public date?: string;
    public user: string;
    public participant: string;
    public action: string;

    public constructor(init?: Partial<DrugManagementLog>) { (Object as any).assign(this, init); }
}

export class ScreenFailure
{
    public id?: number;
    public patientId: number;
    public patient?: Patient;
    public eventId: number;
    public event?: Event;
    public screeningDate?: string;
    public discontinuationDate?: string;
    public enteredBy?: string;
    public modifiedBy?: string;
    public enteredDate?: string;
    public modifiedDate?: string;

    public constructor(init?: Partial<ScreenFailure>) { (Object as any).assign(this, init); }
}

export enum TileInformationDataType
{
    List = 1,
}

export interface ITileInformationData
{
    type: TileInformationDataType;
}

export class BatchDestructionLog
{
    public id?: number;
    public cartonsDestroyed?: number;
    // @References("typeof(NewtonGreen.ServiceStack.DrugManagement.Models.Dos.DrugShipmentDepotBatch)")
    public drugShipmentDepotBatchId?: number;

    public dateActioned?: string;
    public notes?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<BatchDestructionLog>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Ineligible = 2,
    Error = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export enum ValidationErrorType
{
    Warning = 1,
    Ineligible = 2,
    Normal = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class DrugManagementValidationError implements IDrugManagementValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<DrugManagementValidationError>) { (Object as any).assign(this, init); }
}

export class DrugManagementValidationResult
{
    public result: ValidationResultType;
    public errors: DrugManagementValidationError[];

    public constructor(init?: Partial<DrugManagementValidationResult>) { (Object as any).assign(this, init); }
}

export class DrugManagementValidationResponse
{
    public responseStatus: ResponseStatus;
    public validationResult: DrugManagementValidationResult;

    public constructor(init?: Partial<DrugManagementValidationResponse>) { (Object as any).assign(this, init); }
}

export interface IPharmacist
{
    id?: number;
    title: string;
    firstName: string;
    lastName: string;
    deliveryAddress: string;
    deliveryStreet2: string;
    deliverySuburb: string;
    deliveryState: string;
    deliveryPostCode: string;
    deliveryCountry: string;
    email: string;
    phone: string;
    fax: string;
}

export class PharmacyBatchDrugRemaining
{
    public pharmacy: Pharmacy;
    public batch: Batch;
    public drugRemaining?: number;
    public drugAllocated?: number;
    public drugUnits?: number;
    public drugUnitsUsed?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;

    public constructor(init?: Partial<PharmacyBatchDrugRemaining>) { (Object as any).assign(this, init); }
}

export class InvoiceExport
{
    public id?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public invoices?: InvoiceExportInvoice[];

    public constructor(init?: Partial<InvoiceExport>) { (Object as any).assign(this, init); }
}

export class InvoiceExportInvoice
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.InvoiceManagement.Models.Dos.Invoice)")
    public invoiceId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.InvoiceManagement.Models.InvoiceExport)")
    public invoiceExportId?: number;

    public invoice: Invoice;
    public invoiceExport: InvoiceExport;

    public constructor(init?: Partial<InvoiceExportInvoice>) { (Object as any).assign(this, init); }
}

export class InvoiceRequisition implements IDataModel
{
    public id?: number;
    public instCode: string;
    public referenceNumber: string;
    public receiptNumber: string;
    public dateOfApproval?: string;
    public invoices: InvoiceRequisitionInvoice[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<InvoiceRequisition>) { (Object as any).assign(this, init); }
}

export class InvoiceRequisitionInvoice
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.InvoiceManagement.Models.Dos.Invoice)")
    public invoiceId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.InvoiceManagement.Models.InvoiceRequisition)")
    public invoiceRequisitionId?: number;

    public invoice: Invoice;
    public invoiceRequisition: InvoiceRequisition;

    public constructor(init?: Partial<InvoiceRequisitionInvoice>) { (Object as any).assign(this, init); }
}

export class InvoiceType
{
    public id?: number;
    public name: string;
    public cost?: number;
    public cap?: number;
    public ignoreTotalLimit?: boolean;

    public constructor(init?: Partial<InvoiceType>) { (Object as any).assign(this, init); }
}

export interface ILookupItem
{
    id?: number;
    value: string;
    order?: number;
    type?: number;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export class InvoiceManagementValidationError implements IInvoiceManagementValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<InvoiceManagementValidationError>) { (Object as any).assign(this, init); }
}

export class InvoiceManagementValidationResult
{
    public result: ValidationResultType;
    public errors: InvoiceManagementValidationError[];

    public constructor(init?: Partial<InvoiceManagementValidationResult>) { (Object as any).assign(this, init); }
}

export class InvoiceManagementValidationResponse
{
    public responseStatus: ResponseStatus;
    public validationResult: InvoiceManagementValidationResult;

    public constructor(init?: Partial<InvoiceManagementValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFileUploadTemporary
{
    guid: string;
    name: string;
    extension: string;
    fileSize?: number;
    contentType: string;
    image: boolean;
}

export enum UserType
{
    TrialPersonnel = 1,
    Patient = 2,
}

export class LookupItem implements ILookupItem
{
    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    public propertyName: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    public formDefinitionId?: number;
    public formDefinitionCode: string;
    public name: string;
    public propertyName: string;
    public title: string;
    public instructions: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinitionState implements IEventDefinitionFormDefinitionState
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinitionFormDefinition)")
    public eventDefinitionFormDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventDefinitionFormDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinition
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public states: EventDefinitionFormDefinitionState[];

    public constructor(init?: Partial<EventDefinitionFormDefinition>) { (Object as any).assign(this, init); }
}

export class EventDefinitionState implements IEventDefinitionState
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;

    public constructor(init?: Partial<EventDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionErrorMessage implements IEventDefinitionErrorMessage
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventDefinitionErrorMessage>) { (Object as any).assign(this, init); }
}

export class EventDefinition
{
    public id?: number;
    public name: string;
    public code: string;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public formDefinitions: EventDefinitionFormDefinition[];
    public states: EventDefinitionState[];
    public errorMessages: EventDefinitionErrorMessage[];

    public constructor(init?: Partial<EventDefinition>) { (Object as any).assign(this, init); }
}

export enum FormType
{
    Crf = 1,
    Pro = 2,
    Staff = 3,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName: string;
    public label: string;
    public detailedLabel: string;
    public errorMessages: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    public id?: number;
    public code: string;
    public type?: FormType;
    public name: string;
    public instructions: string;
    public patientInstructions: string;
    public properties: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties: { [index: string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export class PatientState implements IPatientState
{
    public id?: number;
    public name: string;
    public order?: number;

    public constructor(init?: Partial<PatientState>) { (Object as any).assign(this, init); }
}

export class Treatment implements ITreatment
{
    public id?: number;
    public name: string;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}

export class MasterGroup implements IMasterGroup
{
    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

export class CollaboratingGroup implements ICollaboratingGroup
{
    public id?: number;
    public masterGroupId?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollaboratingGroup>) { (Object as any).assign(this, init); }
}

export class Country implements ICountry
{
    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class Institution implements IInstitution
{
    public id?: number;
    public countryId?: number;
    public masterGroupId?: number;
    public collaboratingGroupId?: number;
    public code: string;
    public name: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public recruitmentDisabled?: boolean;
    public eConsentActivationDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class PatientValidationError implements IPatientValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<PatientValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationError implements IEventValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationError implements IFormValidationError
{
    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationResult
{
    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public formId?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public completed?: boolean;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public errors: FormValidationError[];

    public constructor(init?: Partial<FormValidationResult>) { (Object as any).assign(this, init); }
}

export class EventValidationResult
{
    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public eventId?: number;
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public errors: EventValidationError[];
    public formResults: FormValidationResult[];

    public constructor(init?: Partial<EventValidationResult>) { (Object as any).assign(this, init); }
}

export class PatientValidationResult
{
    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public patientId?: number;
    public patientDefinitionId?: number;
    public patientRepeat?: number;
    public errors: PatientValidationError[];
    public eventResults: EventValidationResult[];

    public constructor(init?: Partial<PatientValidationResult>) { (Object as any).assign(this, init); }
}

export class EventState implements IEventState
{
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventState>) { (Object as any).assign(this, init); }
}

export class FormState implements IFormState
{
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<FormState>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnel
{
    public id?: number;
    public name: string;
    public email: string;

    public constructor(init?: Partial<InstitutionPersonnel>) { (Object as any).assign(this, init); }
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IInvoiceManagementForm
{
}

export interface IDrugManagementForm
{
}

export interface IPatient extends IDataModel, IHasInstitutionId, IHasPatientStateId, IHasTreatmentId
{
    studyNumber: string;
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasPatientStateId
{
    patientStateId?: number;
}

export interface IHasTreatmentId
{
    treatmentId?: number;
}

export interface IRegistrationPatient
{
    registrationNumber: string;
    registrationDate?: string;
}

export interface IRandomisationPatient
{
    randomisationNumber: string;
    randomisationDate?: string;
}

export interface IEvent extends IDataModel, IHasPatientId, IHasEventDefinitionId
{
    repeat?: number;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasEventDefinitionId
{
    eventDefinitionId?: number;
}

export interface IForm extends IDataModel, IHasPatientId, IHasEventId, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IHasEventId
{
    eventId?: number;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IDrugManagementValidationError extends IValidationError
{
    property: string;
}

export interface IDrugManagementValidationResult extends IValidationResult
{
    errors: IDrugManagementValidationError[];
}

export interface IValidationError
{
    message: string;
    detailedMessage: string;
    code: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    result: ValidationResultType;
    errors: IValidationError[];
}

export interface IInvoiceManagementValidationError extends IValidationError
{
    property: string;
}

export interface IInvoiceManagementValidationResult extends IValidationResult
{
    errors: IInvoiceManagementValidationError[];
}

export interface IEventDefinitionFormDefinitionState extends IConfigurationModel, IHasEventDefinitionFormDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IEventDefinitionFormDefinition extends IConfigurationModel, IHasEventDefinitionId, IHasFormDefinitionId
{
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    states: IEventDefinitionFormDefinitionState[];
}

export interface IEventDefinitionState extends IConfigurationModel, IHasEventDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
}

export interface IEventDefinitionErrorMessage extends IConfigurationModel, IHasEventDefinitionId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IEventDefinition extends IConfigurationModel
{
    name: string;
    code: string;
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    formDefinitions: IEventDefinitionFormDefinition[];
    states: IEventDefinitionState[];
    errorMessages: IEventDefinitionErrorMessage[];
}

export interface IConfigurationModel extends IModel
{
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName: string;
    label: string;
    detailedLabel: string;
    errorMessages: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel
{
    type?: FormType;
    name: string;
    code: string;
    instructions: string;
    patientInstructions: string;
    properties: IFormDefinitionProperty[];
    subformProperties: { [index: string]: IFormDefinitionProperty[]; };
}

export interface IPatientState extends IConfigurationModel
{
    name: string;
    order?: number;
}

export interface ITreatment extends IConfigurationModel
{
    name: string;
}

export interface IMasterGroup extends IDataModel
{
    name: string;
    code: string;
}

export interface ICollaboratingGroup extends IDataModel, IHasMasterGroupId
{
    name: string;
    code: string;
}

export interface IHasMasterGroupId
{
    masterGroupId?: number;
}

export interface ICountry extends IDataModel
{
    name: string;
    code: string;
}

export interface IInstitution extends IDataModel, IHasMasterGroupId, IHasCollaboratingGroupId, IHasCountryId
{
    name: string;
    code: string;
    enabled?: boolean;
    activatedDate?: string;
    recruitmentDisabled?: boolean;
    eConsentActivationDate?: string;
}

export interface IHasCollaboratingGroupId
{
    collaboratingGroupId?: number;
}

export interface IHasCountryId
{
    countryId?: number;
}

export interface IPatientValidationError extends IValidationError
{
}

export interface IEventValidationError extends IValidationError
{
}

export interface IFormValidationError extends IValidationError
{
    property: string;
}

export interface IFormValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    formId?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    completed?: boolean;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    errors: IFormValidationError[];
}

export interface IEventValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    eventDefinitionId?: number;
    eventId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    errors: IEventValidationError[];
    formResults: IFormValidationResult[];
}

export interface IPatientValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    patientId?: number;
    errors: IPatientValidationError[];
    eventResults: IEventValidationResult[];
}

export interface IEventState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IFormState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IFile extends IDataModel, IHasPatientId, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName: string;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IFileUpload
{
    extension: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
    upload: IFileUploadTemporary;
}

export interface IHasEventDefinitionFormDefinitionId
{
    eventDefinitionFormDefinitionId?: number;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export class GetClientAppSettingsResponse
{
    public settings?: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentCreatedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentCreatedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentDeletedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentDeletedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentOrderedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentOrderedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentQuarantinedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentQuarantinedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDrugShipmentReceivedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDrugShipmentReceivedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendStagnantDrugOrdersEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendStagnantDrugOrdersEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendStagnantDrugShipmentsEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendStagnantDrugShipmentsEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendExpiringStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendExpiringStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSiteExpiringStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSiteExpiringStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendLowStockEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendLowStockEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendLateDispensationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendLateDispensationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPatientDrugsChangedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendPatientDrugsChangedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendNoDispensationEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendNoDispensationEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetContactByOutlookIdResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public contact: Contact;

    public constructor(init?: Partial<GetContactByOutlookIdResponse>) { (Object as any).assign(this, init); }
}

export class StartCambriaDrugShipmentGenerationResponse
{
    public responseStatus: ResponseStatus;
    public messages: string[];

    public constructor(init?: Partial<StartCambriaDrugShipmentGenerationResponse>) { (Object as any).assign(this, init); }
}

export class GenerateDrugShipmentsResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GenerateDrugShipmentsResponse>) { (Object as any).assign(this, init); }
}

export class DrugDispensedResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<DrugDispensedResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionBatchesResponse
{
    public institutionBatches: { [index: string]: number[]; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetInstitutionBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsWithNoDispensationsResponse
{
    public responseStatus: ResponseStatus;
    public patientIds: number[];

    public constructor(init?: Partial<GetPatientsWithNoDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetEnumerationTypesResponse
{
    public patientStateType?: PatientStateType;
    public lookupYesNoType?: LookupYesNoType;
    public lookupGenderType?: LookupGenderType;
    public lookupUntypedType?: LookupUntypedType;
    public formDefinitionType?: FormDefinitionType;

    public constructor(init?: Partial<GetEnumerationTypesResponse>) { (Object as any).assign(this, init); }
}

export class SendInvoiceSubmittedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendInvoiceSubmittedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendInvoiceSubmittedSummaryEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendInvoiceSubmittedSummaryEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendMaximumClaimableAmountReachedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendMaximumClaimableAmountReachedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendInvoiceApprovedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendInvoiceApprovedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendInvoiceRejectedEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendInvoiceRejectedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDailyInvoiceSummaryEmailsResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendDailyInvoiceSummaryEmailsResponse>) { (Object as any).assign(this, init); }
}

export class GetReportSettingsResponse
{
    public reportServerUrl: string;
    public reportViewUrl: string;
    public reportDownloadUrl: string;
    public reportFolder: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetReportSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetAbemaReportDataResponse
{
    public responseStatus: ResponseStatus;
    public abemaData: AbemaReportRow[];

    public constructor(init?: Partial<GetAbemaReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugStockDataResponse
{
    public responseStatus: ResponseStatus;
    public drugStockData: DrugStockData[];

    public constructor(init?: Partial<GetDrugStockDataResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentReportDataResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipmentReport[];

    public constructor(init?: Partial<GetDrugShipmentReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientActionReportDataResponse
{
    public responseStatus: ResponseStatus;
    public patientActions: PatientAction[];

    public constructor(init?: Partial<GetPatientActionReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchReportDataResponse
{
    public responseStatus: ResponseStatus;
    public batchReport: BatchReport[];

    public constructor(init?: Partial<GetBatchReportDataResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugManagementLogDataResponse
{
    public responseStatus: ResponseStatus;
    public drugManagementLogs: DrugManagementLog[];

    public constructor(init?: Partial<GetDrugManagementLogDataResponse>) { (Object as any).assign(this, init); }
}

export class GetScreenFailuresResponse
{
    public responseStatus: ResponseStatus;
    public screenFailures: ScreenFailure[];

    public constructor(init?: Partial<GetScreenFailuresResponse>) { (Object as any).assign(this, init); }
}

export class GetScreenFailureResponse
{
    public responseStatus: ResponseStatus;
    public screenFailure: ScreenFailure;

    public constructor(init?: Partial<GetScreenFailureResponse>) { (Object as any).assign(this, init); }
}

export class GetTpRegistrationByInstitutionIdResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpRegistrationByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTpDrugManagementByInstitutionIdResponse
{
    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpDrugManagementByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTpTrialStatusByInstitutionIdResponse
{
    public data: { [index: string]: ITileInformationData; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpTrialStatusByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneWorkbookImportResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public financeMilestones: FinanceMilestone[];

    public constructor(init?: Partial<FinanceMilestoneWorkbookImportResponse>) { (Object as any).assign(this, init); }
}

export class ProcessEmailResponse
{
    public responseStatus: ResponseStatus;
    public result: string;

    public constructor(init?: Partial<ProcessEmailResponse>) { (Object as any).assign(this, init); }
}

export class QueueNewEmailsToParseResponse
{
    public responseStatus: ResponseStatus;
    public count: number;

    public constructor(init?: Partial<QueueNewEmailsToParseResponse>) { (Object as any).assign(this, init); }
}

export class QueueReprocessEmailsToParseResponse
{
    public responseStatus: ResponseStatus;
    public count: number;

    public constructor(init?: Partial<QueueReprocessEmailsToParseResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchDestructionLogsResponse
{
    public responseStatus: ResponseStatus;
    public batchDestructionLogs: BatchDestructionLog[];

    public constructor(init?: Partial<GetBatchDestructionLogsResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<GetBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesByIdsResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesByIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesExpiringAtSpecifiedDateResponse
{
    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDateResponse>) { (Object as any).assign(this, init); }
}

export class SetBatchResponse
{
    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<SetBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<GetDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDepotIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDepotIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByPharmacyIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDrugShipmentIdResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByBatchIdsResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesWithLowStockByDepotIdsResponse
{
    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotBatchResponse
{
    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsResponse
{
    public responseStatus: ResponseStatus;
    public depots: Depot[];

    public constructor(init?: Partial<GetDepotsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotByIdResponse
{
    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<GetDepotByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsByDrugUnderThresholdResponse
{
    public responseStatus: ResponseStatus;
    public depotIds: number[];

    public constructor(init?: Partial<GetDepotsByDrugUnderThresholdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsWithLowStockResponse
{
    public responseStatus: ResponseStatus;
    public depotDrugUnits: DepotDrugUnits[];

    public constructor(init?: Partial<GetDepotsWithLowStockResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotResponse
{
    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<SetDepotResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationsResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetDrugDispensationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsWithLateDispensationsResponse
{
    public responseStatus: ResponseStatus;
    public patientIds: number[];

    public constructor(init?: Partial<GetPatientsWithLateDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetLastDispensationForPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetLastDispensationForPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationsByIdsResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationsByIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugDispensationResponse
{
    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensationResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDrugDispensationResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDrugDispensationResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDrugDispensationResponse extends DrugManagementValidationResponse
{

    public constructor(init?: Partial<ValidateDrugDispensationResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetDrugsResponse
{
    public responseStatus: ResponseStatus;
    public drugs: Drug[];

    public constructor(init?: Partial<GetDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesByPharmacyIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentDepotBatchResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class StartDrugShipmentGenerationResponse
{
    public responseStatus: ResponseStatus;
    public messages: string[];
    public createdDrugShipments: DrugShipment[];

    public constructor(init?: Partial<StartDrugShipmentGenerationResponse>) { (Object as any).assign(this, init); }
}

export class CreateDrugShipmentFromPatientResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<CreateDrugShipmentFromPatientResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<GetDrugShipmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentHistoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentVersions: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentHistoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByIdsResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDrugShipmentResponse extends DrugManagementValidationResponse
{

    public constructor(init?: Partial<ValidateDrugShipmentResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SetDrugShipmentStatusResponse
{
    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDrugShipmentResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentVerifyResponse
{
    public responseStatus: ResponseStatus;
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerifyResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotShippedByExpectedDateResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotReceivedByExpectedDateResponse
{
    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetOrderFormsResponse
{
    public responseStatus: ResponseStatus;
    public orderForms: OrderForm[];

    public constructor(init?: Partial<GetOrderFormsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsByPatientIdResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPatientDrugsResponse
{
    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacistsByInstCodeResponse
{
    public responseStatus: ResponseStatus;
    public pharmacists: IPharmacist[];

    public constructor(init?: Partial<GetPharmacistsByInstCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacistByIdResponse
{
    public responseStatus: ResponseStatus;
    public pharmacist: IPharmacist;

    public constructor(init?: Partial<GetPharmacistByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmaciesResponse
{
    public responseStatus: ResponseStatus;
    public pharmacies: Pharmacy[];

    public constructor(init?: Partial<GetPharmaciesResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByIdResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyBatchesDrugRemainingByBatchIdsResponse
{
    public responseStatus: ResponseStatus;
    public pharmacyBatchesDrugRemaining: PharmacyBatchDrugRemaining[];

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetPharmacyResponse
{
    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacyResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyStockResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyStockResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyDepotBatchResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class ActionQuarantinedStockResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<ActionQuarantinedStockResponse>) { (Object as any).assign(this, init); }
}

export class QuarantineRemovePharmacyDepotBatchResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuarantineRemovePharmacyDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyEmailsResponse
{
    public responseStatus: ResponseStatus;
    public emailAddresses: MailAddress[];

    public constructor(init?: Partial<GetPharmacyEmailsResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyBatchesResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyBatchesResponse>) { (Object as any).assign(this, init); }
}

export class ActionQuarantinedPharmacyBatchesResponse
{
    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<ActionQuarantinedPharmacyBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetTimepointsResponse
{
    public responseStatus: ResponseStatus;
    public timepoints: Timepoint[];

    public constructor(init?: Partial<GetTimepointsResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceExportsResponse
{
    public responseStatus: ResponseStatus;
    public exports: InvoiceExport[];

    public constructor(init?: Partial<GetInvoiceExportsResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceExportsMetadataResponse
{
    public responseStatus: ResponseStatus;
    public availableInvoices: number;

    public constructor(init?: Partial<GetInvoiceExportsMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceExportByIdResponse
{
    public responseStatus: ResponseStatus;
    public export: InvoiceExport;

    public constructor(init?: Partial<GetInvoiceExportByIdResponse>) { (Object as any).assign(this, init); }
}

export class PostCreateExportResponse
{
    public responseStatus: ResponseStatus;
    public export: InvoiceExport;

    public constructor(init?: Partial<PostCreateExportResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceRequisitionsResponse
{
    public responseStatus: ResponseStatus;
    public requisitions: InvoiceRequisition[];

    public constructor(init?: Partial<GetInvoiceRequisitionsResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceRequisitionsByInstitutionCodeResponse
{
    public responseStatus: ResponseStatus;
    public requisitions: InvoiceRequisition[];

    public constructor(init?: Partial<GetInvoiceRequisitionsByInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceRequisitionByIdResponse
{
    public responseStatus: ResponseStatus;
    public requisition: InvoiceRequisition;

    public constructor(init?: Partial<GetInvoiceRequisitionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceRequisitionMetadataResponse
{
    public responseStatus: ResponseStatus;
    public cooldownPeriods: { [index: string]: string; };
    public availableInvoices: { [index: string]: number; };

    public constructor(init?: Partial<GetInvoiceRequisitionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class PostCreateInvoiceRequisitionResponse
{
    public responseStatus: ResponseStatus;
    public requisition: InvoiceRequisition;

    public constructor(init?: Partial<PostCreateInvoiceRequisitionResponse>) { (Object as any).assign(this, init); }
}

export class PostApproveInvoiceRequisitionResponse
{
    public responseStatus: ResponseStatus;
    public requisition: InvoiceRequisition;

    public constructor(init?: Partial<PostApproveInvoiceRequisitionResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoicesResponse
{
    public responseStatus: ResponseStatus;
    public invoices: Invoice[];

    public constructor(init?: Partial<GetInvoicesResponse>) { (Object as any).assign(this, init); }
}

export class QueryInvoicesResponse
{
    public responseStatus: ResponseStatus;
    public invoices: Invoice[];

    public constructor(init?: Partial<QueryInvoicesResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceByIdResponse
{
    public responseStatus: ResponseStatus;
    public invoice: Invoice;

    public constructor(init?: Partial<GetInvoiceByIdResponse>) { (Object as any).assign(this, init); }
}

export class SaveInvoiceResponse
{
    public responseStatus: ResponseStatus;
    public invoice?: Invoice;

    public constructor(init?: Partial<SaveInvoiceResponse>) { (Object as any).assign(this, init); }
}

export class SetInvoiceStatusResponse
{
    public responseStatus: ResponseStatus;
    public invoice?: Invoice;

    public constructor(init?: Partial<SetInvoiceStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInvoiceResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInvoiceResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceTypesResponse
{
    public responseStatus: ResponseStatus;
    public invoiceTypes: InvoiceType[];

    public constructor(init?: Partial<GetInvoiceTypesResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceLookupsResponse
{
    public responseStatus: ResponseStatus;
    public lookups: ILookup[];

    public constructor(init?: Partial<GetInvoiceLookupsResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInvoiceResponse extends InvoiceManagementValidationResponse
{

    public constructor(init?: Partial<ValidateInvoiceResponse>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=13)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    public responseStatus: ResponseStatus;
    public upload: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public type?: UserType;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    public responseStatus: ResponseStatus;
    public formMetadata: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definition. */
    // @DataMember(Order=2)
    public eventDefinition: EventDefinition;

    public constructor(init?: Partial<EventDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definitions. */
    // @DataMember(Order=2)
    public eventDefinitions: EventDefinition[];

    public constructor(init?: Partial<EventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public formDefinition: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public formDefinitions: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient state. */
    // @DataMember(Order=2)
    public patientState: PatientState;

    public constructor(init?: Partial<PatientStateSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient states. */
    // @DataMember(Order=2)
    public patientStates: PatientState[];

    public constructor(init?: Partial<PatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatment. */
    // @DataMember(Order=2)
    public treatment: Treatment;

    public constructor(init?: Partial<TreatmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatments. */
    // @DataMember(Order=2)
    public treatments: Treatment[];

    public constructor(init?: Partial<TreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master group. */
    // @DataMember(Order=2)
    public masterGroup: MasterGroup;

    public constructor(init?: Partial<MasterGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master groups. */
    // @DataMember(Order=2)
    public masterGroups: MasterGroup[];

    public constructor(init?: Partial<MasterGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating group. */
    // @DataMember(Order=2)
    public collaboratingGroup: CollaboratingGroup;

    public constructor(init?: Partial<CollaboratingGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating groups. */
    // @DataMember(Order=2)
    public collaboratingGroups: CollaboratingGroup[];

    public constructor(init?: Partial<CollaboratingGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountrySingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved country. */
    // @DataMember(Order=2)
    public country: Country;

    public constructor(init?: Partial<CountrySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved countrys. */
    // @DataMember(Order=2)
    public countries: Country[];

    public constructor(init?: Partial<CountryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institution. */
    // @DataMember(Order=2)
    public institution: Institution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institutions. */
    // @DataMember(Order=2)
    public institutions: Institution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient. */
    // @DataMember(Order=2)
    public patient: Patient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientValidationResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: PatientValidationResult;

    public constructor(init?: Partial<PatientValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patients. */
    // @DataMember(Order=2)
    public patients: Patient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event. */
    // @DataMember(Order=2)
    public event: Event;

    public constructor(init?: Partial<EventSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved events. */
    // @DataMember(Order=2)
    public events: Event[];

    public constructor(init?: Partial<EventCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved source document. */
    // @DataMember(Order=2)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved source documents. */
    // @DataMember(Order=2)
    public forms: SourceDocument[];

    public constructor(init?: Partial<SourceDocumentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentDeleteResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SourceDocumentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentValidationResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SourceDocumentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved finance milestone. */
    // @DataMember(Order=2)
    public form: FinanceMilestone;

    public constructor(init?: Partial<FinanceMilestoneSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved finance milestones. */
    // @DataMember(Order=2)
    public forms: FinanceMilestone[];

    public constructor(init?: Partial<FinanceMilestoneCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneDeleteResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<FinanceMilestoneDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneValidationResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<FinanceMilestoneValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationSingleResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registration. */
    // @DataMember(Order=2)
    public form: Registration;

    public constructor(init?: Partial<RegistrationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationCollectionResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registrations. */
    // @DataMember(Order=2)
    public forms: Registration[];

    public constructor(init?: Partial<RegistrationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationDeleteResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegistrationDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationValidationResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<RegistrationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventStateResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event states for the patient. */
    // @DataMember(Order=2)
    public states: EventState[];

    public constructor(init?: Partial<EventStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormStateResponse
{
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form states for the patient event. */
    // @DataMember(Order=2)
    public states: FormState[];

    public constructor(init?: Partial<FormStateResponse>) { (Object as any).assign(this, init); }
}

export class HasOpmsPermissionCollectionResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: { [index: number]: boolean; };

    public constructor(init?: Partial<HasOpmsPermissionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelResponse
{
    public responseStatus: ResponseStatus;
    public personnel: { [index: number]: InstitutionPersonnel; };

    public constructor(init?: Partial<InstitutionPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelNamesResponse
{
    public responseStatus: ResponseStatus;
    public personnelNames: { [index: number]: string; };

    public constructor(init?: Partial<InstitutionPersonnelNamesResponse>) { (Object as any).assign(this, init); }
}

export class TrialPersonnelActiveRoleResponse
{
    public responseStatus: ResponseStatus;
    public hasRole: { [index: number]: boolean; };

    public constructor(init?: Partial<TrialPersonnelActiveRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/drug-management-api/send-drug-created-email")
export class SendDrugShipmentCreatedEmail implements IReturn<SendDrugShipmentCreatedEmailResponse>, IPost
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendDrugShipmentCreatedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDrugShipmentCreatedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDrugShipmentCreatedEmailResponse(); }
}

// @Route("/drug-management-api/send-drug-deleted-email")
export class SendDrugShipmentDeletedEmail implements IReturn<SendDrugShipmentDeletedEmailResponse>, IPost
{
    public drugShipmentId?: number;
    public reason: string;

    public constructor(init?: Partial<SendDrugShipmentDeletedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDrugShipmentDeletedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDrugShipmentDeletedEmailResponse(); }
}

// @Route("/drug-management-api/send-drug-ordered-email")
export class SendDrugShipmentOrderedEmail implements IReturn<SendDrugShipmentOrderedEmailResponse>, IPost
{
    public drugShipmentId: number;

    public constructor(init?: Partial<SendDrugShipmentOrderedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDrugShipmentOrderedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDrugShipmentOrderedEmailResponse(); }
}

// @Route("/drug-management-api/send-drug-quarantined-email")
export class SendDrugShipmentQuarantinedEmail implements IReturn<SendDrugShipmentQuarantinedEmailResponse>, IPost
{
    public drugShipmentId: number;

    public constructor(init?: Partial<SendDrugShipmentQuarantinedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDrugShipmentQuarantinedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDrugShipmentQuarantinedEmailResponse(); }
}

// @Route("/drug-management-api/send-drug-received-email")
export class SendDrugShipmentReceivedEmail implements IReturn<SendDrugShipmentReceivedEmailResponse>, IPost
{
    public drugShipmentId: number;

    public constructor(init?: Partial<SendDrugShipmentReceivedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDrugShipmentReceivedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDrugShipmentReceivedEmailResponse(); }
}

// @Route("/drug-management-api/send-stagnant-drug-orders-email")
export class SendStagnantDrugOrdersEmail implements IReturn<SendStagnantDrugOrdersEmailResponse>, IPost
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendStagnantDrugOrdersEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendStagnantDrugOrdersEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendStagnantDrugOrdersEmailResponse(); }
}

// @Route("/drug-management-api/send-stagnant-drug-shipments-email")
export class SendStagnantDrugShipmentsEmail implements IReturn<SendStagnantDrugShipmentsEmailResponse>, IPost
{
    public drugShipmentIds: number[];

    public constructor(init?: Partial<SendStagnantDrugShipmentsEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendStagnantDrugShipmentsEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendStagnantDrugShipmentsEmailResponse(); }
}

// @Route("/drug-management-api/send-expiring-stock-email")
export class SendExpiringStockEmail implements IReturn<SendExpiringStockEmailResponse>, IPost
{
    public batchIds: number[];

    public constructor(init?: Partial<SendExpiringStockEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendExpiringStockEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendExpiringStockEmailResponse(); }
}

// @Route("/drug-management-api/send-site-expiring-stock-email")
export class SendSiteExpiringStockEmail implements IReturn<SendSiteExpiringStockEmailResponse>, IPost
{
    public institutionCode: string;
    public batchIds: number[];

    public constructor(init?: Partial<SendSiteExpiringStockEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSiteExpiringStockEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSiteExpiringStockEmailResponse(); }
}

// @Route("/drug-management-api/send-low-stock-email")
export class SendLowStockEmail implements IReturn<SendLowStockEmailResponse>, IPost
{
    public depotDrugUnits: DepotDrugUnits[];

    public constructor(init?: Partial<SendLowStockEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendLowStockEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendLowStockEmailResponse(); }
}

// @Route("/drug-management-api/send-late-dispensation-email")
export class SendLateDispensationEmail implements IReturn<SendLateDispensationEmailResponse>, IPost
{
    public patientId: number;

    public constructor(init?: Partial<SendLateDispensationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendLateDispensationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendLateDispensationEmailResponse(); }
}

// @Route("/drug-management-api/send-patient-drugs-changed-email")
export class SendPatientDrugsChangedEmail implements IReturn<SendPatientDrugsChangedEmailResponse>, IPost
{
    public patientId: number;
    public modifiedDate?: string;
    public modifiedBy: string;
    public previousPatientDrugs: string;
    public currentPatientDrugs: string;

    public constructor(init?: Partial<SendPatientDrugsChangedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendPatientDrugsChangedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendPatientDrugsChangedEmailResponse(); }
}

// @Route("/drug-management-api/send-no-dispensation-email")
export class SendNoDispensationEmail implements IReturn<SendNoDispensationEmailResponse>, IPost
{
    public patientId: number;

    public constructor(init?: Partial<SendNoDispensationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendNoDispensationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendNoDispensationEmailResponse(); }
}

/** @description TMD */
// @Route("/contact/by-outlook-id", "GET")
// @Api(Description="TMD")
// @ApiResponse(Description="Not authorized", StatusCode=401)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetContactByOutlookId implements IReturn<GetContactByOutlookIdResponse>, IGet
{
    /** @description The outlook id of the contact to get */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The outlook id of the contact to get", IsRequired=true, Name="OutlookId", ParameterType="query")
    public outlookId: string;

    public constructor(init?: Partial<GetContactByOutlookId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetContactByOutlookId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetContactByOutlookIdResponse(); }
}

// @Route("/drug-management-api/cambria-drug-shipment-generation/queue", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class StartCambriaDrugShipmentGeneration implements IReturn<StartCambriaDrugShipmentGenerationResponse>
{

    public constructor(init?: Partial<StartCambriaDrugShipmentGeneration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartCambriaDrugShipmentGeneration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartCambriaDrugShipmentGenerationResponse(); }
}

// @Route("/drug-management-api/generate-drug-shipments/queue", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GenerateDrugShipments implements IReturn<GenerateDrugShipmentsResponse>
{

    public constructor(init?: Partial<GenerateDrugShipments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenerateDrugShipments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GenerateDrugShipmentsResponse(); }
}

export class DrugDispensed implements IReturn<DrugDispensedResponse>, IPost
{
    public patientId: number;
    public dispensationIds: number[];

    public constructor(init?: Partial<DrugDispensed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DrugDispensed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DrugDispensedResponse(); }
}

export class GetInstitutionBatches implements IReturn<GetInstitutionBatchesResponse>
{
    public batchIds: number[];

    public constructor(init?: Partial<GetInstitutionBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionBatchesResponse(); }
}

// @Route("/drug-management-api/get-patients-no-dispensations")
export class GetPatientsWithNoDispensations implements IReturn<GetPatientsWithNoDispensationsResponse>, IGet
{

    public constructor(init?: Partial<GetPatientsWithNoDispensations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsWithNoDispensations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsWithNoDispensationsResponse(); }
}

export class GetEnumerationTypes implements IReturn<GetEnumerationTypesResponse>
{

    public constructor(init?: Partial<GetEnumerationTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEnumerationTypes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetEnumerationTypesResponse(); }
}

// @Route("/invoicemanagement-management-api/send-invoice-submitted-email")
export class SendInvoiceSubmittedEmail implements IReturn<SendInvoiceSubmittedEmailResponse>, IPost
{
    public invoiceId: number;
    public newInvoice: boolean;

    public constructor(init?: Partial<SendInvoiceSubmittedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendInvoiceSubmittedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendInvoiceSubmittedEmailResponse(); }
}

// @Route("/invoicemanagement-management-api/send-invoice-submitted-summary-email")
export class SendInvoiceSubmittedSummaryEmail implements IReturn<SendInvoiceSubmittedSummaryEmailResponse>, IPost
{
    public summaryDate?: string;

    public constructor(init?: Partial<SendInvoiceSubmittedSummaryEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendInvoiceSubmittedSummaryEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendInvoiceSubmittedSummaryEmailResponse(); }
}

// @Route("/invoicemanagement-management-api/send-maximum-claimable-amount-reached-email")
export class SendMaximumClaimableAmountReachedEmail implements IReturn<SendMaximumClaimableAmountReachedEmailResponse>, IPost
{
    public invoiceId?: number;
    public patientId?: number;

    public constructor(init?: Partial<SendMaximumClaimableAmountReachedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendMaximumClaimableAmountReachedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendMaximumClaimableAmountReachedEmailResponse(); }
}

// @Route("/invoicemanagement-management-api/send-invoice-approved-email")
export class SendInvoiceApprovedEmail implements IReturn<SendInvoiceApprovedEmailResponse>, IPost
{
    public invoiceId: number;

    public constructor(init?: Partial<SendInvoiceApprovedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendInvoiceApprovedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendInvoiceApprovedEmailResponse(); }
}

// @Route("/invoicemanagement-management-api/send-invoice-rejected-email")
export class SendInvoiceRejectedEmail implements IReturn<SendInvoiceRejectedEmailResponse>, IPost
{
    public invoiceId: number;

    public constructor(init?: Partial<SendInvoiceRejectedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendInvoiceRejectedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendInvoiceRejectedEmailResponse(); }
}

// @Route("/invoicemanagement-management-api/send-daily-invoice-summary-emails")
export class SendDailyInvoiceSummaryEmails implements IReturn<SendDailyInvoiceSummaryEmailsResponse>, IPost
{
    public invoices?: Invoice[];
    public targetDate?: string;

    public constructor(init?: Partial<SendDailyInvoiceSummaryEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDailyInvoiceSummaryEmails'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDailyInvoiceSummaryEmailsResponse(); }
}

// @Route("/opms/report/settings/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetReportSettings implements IReturn<GetReportSettingsResponse>
{

    public constructor(init?: Partial<GetReportSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReportSettingsResponse(); }
}

// @Route("/report/abema-data", "GET,POST")
export class GetAbemaReportData implements IReturn<GetAbemaReportDataResponse>, IReportRequest
{
    public token: string;

    public constructor(init?: Partial<GetAbemaReportData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAbemaReportData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAbemaReportDataResponse(); }
}

// @Route("/report/drug-stock", "GET,POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDrugStockData implements IReturn<GetDrugStockDataResponse>, IReportRequest
{
    public token: string;

    public constructor(init?: Partial<GetDrugStockData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugStockData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetDrugStockDataResponse(); }
}

// @Route("/report/drug-shipment", "GET,POST")
export class GetDrugShipmentReportData implements IReturn<GetDrugShipmentReportDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugShipmentReportData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentReportData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetDrugShipmentReportDataResponse(); }
}

// @Route("/report/patient-action", "GET,POST")
export class GetPatientActionReportData implements IReturn<GetPatientActionReportDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetPatientActionReportData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientActionReportData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPatientActionReportDataResponse(); }
}

// @Route("/report/batch", "GET,POST")
export class GetBatchReportData implements IReturn<GetBatchReportDataResponse>, IReportRequest
{
    public token: string;

    public constructor(init?: Partial<GetBatchReportData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchReportData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetBatchReportDataResponse(); }
}

// @Route("/report/drug-management-log", "GET,POST")
export class GetDrugManagementLogData implements IReturn<GetDrugManagementLogDataResponse>, IReportRequest
{
    public token: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugManagementLogData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugManagementLogData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetDrugManagementLogDataResponse(); }
}

// @Route("/api/screenfailures", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetScreenFailures implements IReturn<GetScreenFailuresResponse>
{

    public constructor(init?: Partial<GetScreenFailures>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetScreenFailures'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetScreenFailuresResponse(); }
}

// @Route("/api/screenfailure", "POST")
// @ApiResponse(Description="id is invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetScreenFailure implements IReturn<GetScreenFailureResponse>
{
    /** @description The primary id of the ScreenFailure. */
    // @ApiMember(DataType="int", Description="The primary id of the ScreenFailure.", Name="Id", ParameterType="path")
    public id?: number;

    public constructor(init?: Partial<GetScreenFailure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetScreenFailure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetScreenFailureResponse(); }
}

// @Route("/get/tp-registration/", "GET")
// @Route("/get/tp-registration/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpRegistrationByInstitutionId implements IReturn<GetTpRegistrationByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpRegistrationByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpRegistrationByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpRegistrationByInstitutionIdResponse(); }
}

// @Route("/get/tp-drug-management/", "GET")
// @Route("/get/tp-drug-management/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpDrugManagementByInstitutionId implements IReturn<GetTpDrugManagementByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpDrugManagementByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpDrugManagementByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpDrugManagementByInstitutionIdResponse(); }
}

// @Route("/get/tp-trial-status/", "GET")
// @Route("/get/tp-trial-status/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpTrialStatusByInstitutionId implements IReturn<GetTpTrialStatusByInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTpTrialStatusByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpTrialStatusByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpTrialStatusByInstitutionIdResponse(); }
}

// @DataContract
export class FinanceMilestoneWorkbookPostImport implements IReturn<FinanceMilestoneWorkbookImportResponse>, IPost
{

    public constructor(init?: Partial<FinanceMilestoneWorkbookPostImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneWorkbookPostImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneWorkbookImportResponse(); }
}

export class ProcessEmail implements IReturn<ProcessEmailResponse>
{
    public id: string;

    public constructor(init?: Partial<ProcessEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcessEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcessEmailResponse(); }
}

export class QueueNewEmailsToParse implements IReturn<QueueNewEmailsToParseResponse>
{

    public constructor(init?: Partial<QueueNewEmailsToParse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueNewEmailsToParse'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueNewEmailsToParseResponse(); }
}

export class QueueReprocessEmailsToParse implements IReturn<QueueReprocessEmailsToParseResponse>
{

    public constructor(init?: Partial<QueueReprocessEmailsToParse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueReprocessEmailsToParse'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueReprocessEmailsToParseResponse(); }
}

// @Route("/drug-management-api/batch-destruction-logs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchDestructionLogs implements IReturn<GetBatchDestructionLogsResponse>
{

    public constructor(init?: Partial<GetBatchDestructionLogs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchDestructionLogs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchDestructionLogsResponse(); }
}

// @Route("/drug-management-api/batch-destruction-logs/drugShipmentDepotBatchId/{DrugShipmentDepotBatchId}", "GET")
// @ApiResponse(Description="DrugShipmentDepotBatch Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchDestructionLogsByDrugShipmentDepotBatchId implements IReturn<GetBatchDestructionLogsResponse>
{
    /** @description The id of the drug shipment depot batch */
    // @ApiMember(DataType="int", Description="The id of the drug shipment depot batch", IsRequired=true, Name="DrugShipmentDepotBatchId", ParameterType="path")
    public drugShipmentDepotBatchId: number;

    public constructor(init?: Partial<GetBatchDestructionLogsByDrugShipmentDepotBatchId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchDestructionLogsByDrugShipmentDepotBatchId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchDestructionLogsResponse(); }
}

// @Route("/drug-management-api/batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatches implements IReturn<GetBatchesResponse>
{

    public constructor(init?: Partial<GetBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesResponse(); }
}

// @Route("/drug-management-api/batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchById implements IReturn<GetBatchByIdResponse>
{
    /** @description The id of the drug batch */
    // @ApiMember(DataType="int", Description="The id of the drug batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchByIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesByIds implements IReturn<GetBatchesByIdsResponse>, IGet
{
    public ids: number[];

    public constructor(init?: Partial<GetBatchesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesByIdsResponse(); }
}

// @Route("/drug-management-api/batches/expiring-at-specified-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesExpiringAtSpecifiedDate implements IReturn<GetBatchesExpiringAtSpecifiedDateResponse>, IGet
{
    /** @description The date of expiry */
    // @ApiMember(DataType="DateTime", Description="The date of expiry", IsRequired=true, Name="ExpiryDate", ParameterType="query")
    public expiryDate: string;

    /** @description Whether to include batches with no drug remaining (default false) */
    // @ApiMember(DataType="boolean", Description="Whether to include batches with no drug remaining (default false)", Name="IncludeExhaustedBatches", ParameterType="query")
    public includeExhaustedBatches?: boolean;

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchesExpiringAtSpecifiedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesExpiringAtSpecifiedDateResponse(); }
}

// @Route("/drug-management-api/batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetBatch implements IReturn<SetBatchResponse>
{
    /** @description The drug batch form data to save */
    // @ApiMember(DataType="BatchForm", Description="The drug batch form data to save", IsRequired=true, Name="BatchForm", ParameterType="body")
    public batch: Batch;

    public constructor(init?: Partial<SetBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetBatchResponse(); }
}

// @Route("/drug-management-api/depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatches implements IReturn<GetDepotBatchesResponse>
{

    public constructor(init?: Partial<GetDepotBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesResponse(); }
}

// @Route("/drug-management-api/depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchById implements IReturn<GetDepotBatchByIdResponse>
{
    /** @description The id of the depot batch */
    // @ApiMember(DataType="int", Description="The id of the depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchByIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/depotId/{DepotId}", "GET")
// @ApiResponse(Description="Depot Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDepotId implements IReturn<GetDepotBatchesByDepotIdResponse>
{
    /** @description The id of the depot */
    // @ApiMember(DataType="int", Description="The id of the depot", IsRequired=true, Name="DepotId", ParameterType="path")
    public depotId: number;

    public constructor(init?: Partial<GetDepotBatchesByDepotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByDepotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByDepotIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByPharmacyId implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByPharmacyId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/drugShipmentId/{DrugShipmentId}", "GET")
// @ApiResponse(Description="Drug Shipment Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDrugShipmentId implements IReturn<GetDepotBatchesByDrugShipmentIdResponse>
{
    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="DrugShipmentId", ParameterType="path")
    public drugShipmentId: number;

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByDrugShipmentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByDrugShipmentIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByInstitutionCode implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    /** @description The institution code */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByBatchIds implements IReturn<GetDepotBatchesByBatchIdsResponse>, IGet
{
    public batchIds: number[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByBatchIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByBatchIdsResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesWithLowStockByDepotIds implements IReturn<GetDepotBatchesWithLowStockByDepotIdsResponse>, IGet
{
    public depotIds: number[];
    public drugThreshold?: number;

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesWithLowStockByDepotIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesWithLowStockByDepotIdsResponse(); }
}

// @Route("/drug-management-api/depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepotBatch implements IReturn<SetDepotBatchResponse>
{
    /** @description The depot batch form data to save */
    // @ApiMember(DataType="DepotBatch", Description="The depot batch form data to save", IsRequired=true, Name="DepotBatch", ParameterType="body")
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepotBatchResponse(); }
}

// @Route("/drug-management-api/depots", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepots implements IReturn<GetDepotsResponse>, IGet
{

    public constructor(init?: Partial<GetDepots>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepots'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotsResponse(); }
}

// @Route("/drug-management-api/depot/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotById implements IReturn<GetDepotByIdResponse>, IGet
{
    /** @description The id of the drug depot */
    // @ApiMember(DataType="int", Description="The id of the drug depot", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotByIdResponse(); }
}

// @Route("/drug-management-api/depots/by-drug-under-threshold", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotsByDrugUnderThreshold implements IReturn<GetDepotsByDrugUnderThresholdResponse>, IGet
{
    /** @description The threshold to check */
    // @ApiMember(DataType="int", Description="The threshold to check", IsRequired=true, Name="DrugThreshold", ParameterType="query")
    public drugThreshold: number;

    public constructor(init?: Partial<GetDepotsByDrugUnderThreshold>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotsByDrugUnderThreshold'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotsByDrugUnderThresholdResponse(); }
}

// @Route("/drug-management-api/depots/low-stock", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotsWithLowStock implements IReturn<GetDepotsWithLowStockResponse>, IGet
{

    public constructor(init?: Partial<GetDepotsWithLowStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotsWithLowStock'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotsWithLowStockResponse(); }
}

// @Route("/drug-management-api/depot/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepot implements IReturn<SetDepotResponse>
{
    /** @description The drug depot form data to save */
    // @ApiMember(DataType="DepotForm", Description="The drug depot form data to save", IsRequired=true, Name="DepotForm", ParameterType="body")
    public depot: Depot;

    public constructor(init?: Partial<SetDepot>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepot'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepotResponse(); }
}

// @Route("/drug-management-api/drug-dispensations", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensations implements IReturn<GetDrugDispensationsResponse>, IGet
{

    public constructor(init?: Partial<GetDrugDispensations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationsResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationById implements IReturn<GetDrugDispensationByIdResponse>, IGet
{
    /** @description The id of the drug dispensation */
    // @ApiMember(DataType="int", Description="The id of the drug dispensation", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugDispensationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationByIdResponse(); }
}

// @Route("/drug-management-api/drug-dispensations/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationByPatientId implements IReturn<GetDrugDispensationByPatientIdResponse>, IGet
{
    /** @description The id of the patient to retrieve drug dispensations for */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve drug dispensations for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetDrugDispensationByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationByPatientIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientsWithLateDispensations implements IReturn<GetPatientsWithLateDispensationsResponse>, IGet
{
    public expectedDate?: string;

    public constructor(init?: Partial<GetPatientsWithLateDispensations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsWithLateDispensations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsWithLateDispensationsResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLastDispensationForPatientId implements IReturn<GetLastDispensationForPatientIdResponse>, IGet
{
    public patientId?: number;

    public constructor(init?: Partial<GetLastDispensationForPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLastDispensationForPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLastDispensationForPatientIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationsByIds implements IReturn<GetDrugDispensationsByIdsResponse>, IGet
{
    public ids: number[];

    public constructor(init?: Partial<GetDrugDispensationsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationsByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationsByIdsResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugDispensation implements IReturn<SetDrugDispensationResponse>, IPost
{
    /** @description The patient dispensation form data to save */
    // @ApiMember(DataType="DrugDispensation", Description="The patient dispensation form data to save", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugDispensationResponse(); }
}

export class DeleteDrugDispensation implements IReturn<DeleteDrugDispensationResponse>
{
    /** @description The drug dispensation we want to delete */
    // @ApiMember(DataType="DrugDispensation", Description="The drug dispensation we want to delete", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<DeleteDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteDrugDispensationResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/validate", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateDrugDispensation implements IReturn<ValidateDrugDispensationResponse>, IPost
{
    /** @description The drug dispensation form data to validate */
    // @ApiMember(DataType="model", Description="The drug dispensation form data to validate", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<ValidateDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateDrugDispensationResponse(); }
}

// @Route("/drug-management-api/drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugs implements IReturn<GetDrugsResponse>
{

    public constructor(init?: Partial<GetDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugsResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatches implements IReturn<GetDrugShipmentDepotBatchesResponse>
{

    public constructor(init?: Partial<GetDrugShipmentDepotBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchById implements IReturn<GetDrugShipmentDepotBatchByIdResponse>
{
    /** @description The id of the drug shipment depot batch */
    // @ApiMember(DataType="int", Description="The id of the drug shipment depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchByIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByPharmacyId implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByPharmacyId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByInstitutionCode implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    /** @description The institution code */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentDepotBatch implements IReturn<SetDrugShipmentDepotBatchResponse>
{
    /** @description The drug shipment depot batch form data to save */
    // @ApiMember(DataType="DrugShipmentDepotBatch", Description="The drug shipment depot batch form data to save", IsRequired=true, Name="DrugShipmentDepotBatch", ParameterType="body")
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentDepotBatchResponse(); }
}

// @Route("/drug-management-api/drug-shipment-generation/queue", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class StartDrugShipmentGeneration implements IReturn<StartDrugShipmentGenerationResponse>
{

    public constructor(init?: Partial<StartDrugShipmentGeneration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartDrugShipmentGeneration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartDrugShipmentGenerationResponse(); }
}

// @Route("/drug-management-api/drug-shipment-generation/create-from-patient", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDrugShipmentFromPatient implements IReturn<CreateDrugShipmentFromPatientResponse>, IPost
{
    /** @description The id of the patient */
    // @ApiMember(DataType="int", Description="The id of the patient", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /** @description The drugs to order for the patient */
    // @ApiMember(DataType="model", Description="The drugs to order for the patient", IsRequired=true, Name="Drugs", ParameterType="body")
    public drugs: DrugAmount[];

    public constructor(init?: Partial<CreateDrugShipmentFromPatient>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDrugShipmentFromPatient'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDrugShipmentFromPatientResponse(); }
}

// @Route("/drug-management-api/drug-shipments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipments implements IReturn<GetDrugShipmentsResponse>, IGet
{

    public constructor(init?: Partial<GetDrugShipments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsResponse(); }
}

// @Route("/drug-management-api/drug-shipments/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByInstitution implements IReturn<GetDrugShipmentsByInstitutionResponse>, IGet
{
    /** @description The institution of the pharmacies */
    // @ApiMember(DataType="string", Description="The institution of the pharmacies", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugShipmentsByInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsByInstitution'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsByInstitutionResponse(); }
}

// @Route("/drug-management-api/drug-shipment/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentById implements IReturn<GetDrugShipmentByIdResponse>, IGet
{
    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentByIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-history/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentHistoryById implements IReturn<GetDrugShipmentHistoryByIdResponse>, IGet
{
    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentHistoryById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentHistoryById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentHistoryByIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByIds implements IReturn<GetDrugShipmentsByIdsResponse>, IGet
{
    public ids: number[];

    public constructor(init?: Partial<GetDrugShipmentsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsByIdsResponse(); }
}

// @Route("/drug-management-api/drug-shipment/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipment implements IReturn<SetDrugShipmentResponse>, IPost
{
    /** @description The drug shipment form data to save */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/validate", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateDrugShipment implements IReturn<ValidateDrugShipmentResponse>, IPost
{
    /** @description The drug shipment form data to validate */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to validate", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<ValidateDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/set-status", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentStatus implements IReturn<SetDrugShipmentStatusResponse>, IPost
{
    /** @description The drug shipment form data to save */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentStatusResponse(); }
}

// @Route("/drug-management-api/drug-shipment/delete", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteDrugShipment implements IReturn<DeleteDrugShipmentResponse>, IPost
{
    /** @description The drug shipment id to delete */
    // @ApiMember(DataType="int", Description="The drug shipment id to delete", IsRequired=true, Name="DrugShipmentId", ParameterType="body")
    public drugShipmentId: number;

    /** @description The reason for drug shipment deletion */
    // @ApiMember(DataType="string", Description="The reason for drug shipment deletion", IsRequired=true, Name="Reason", ParameterType="body")
    public reason: string;

    public constructor(init?: Partial<DeleteDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/verify", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentVerify implements IReturn<SetDrugShipmentVerifyResponse>, IPost
{
    /** @description The drug shipment form data to verify */
    // @ApiMember(DataType="model", Description="The drug shipment form data to verify", IsRequired=true, Name="DrugShipmentVerify", ParameterType="body")
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerify>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentVerify'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentVerifyResponse(); }
}

// @Route("/drug-management-api/drug-shipments/not-shipped-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotShippedByExpectedDate implements IReturn<GetDrugShipmentsNotShippedByExpectedDateResponse>, IGet
{
    /** @description The date to check from */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedShippingDate", ParameterType="query")
    public expectedShippingDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsNotShippedByExpectedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsNotShippedByExpectedDateResponse(); }
}

// @Route("/drug-management-api/drug-shipments/not-received-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotReceivedByExpectedDate implements IReturn<GetDrugShipmentsNotReceivedByExpectedDateResponse>, IGet
{
    /** @description The date to check from */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedReceptionDate", ParameterType="query")
    public expectedReceptionDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsNotReceivedByExpectedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsNotReceivedByExpectedDateResponse(); }
}

// @Route("/drug-management-api/drug-shipment-order-form/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentOrderFormById implements IReturn<Blob>, IGet
{
    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentOrderFormById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentOrderFormById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/drug-management-api/order-forms", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetOrderForms implements IReturn<GetOrderFormsResponse>
{

    public constructor(init?: Partial<GetOrderForms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOrderForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOrderFormsResponse(); }
}

// @Route("/drug-management-api/patient-drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugs implements IReturn<GetPatientDrugsResponse>, IGet
{

    public constructor(init?: Partial<GetPatientDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientDrugs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientDrugsResponse(); }
}

// @Route("/drug-management-api/patient-drugs/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugsByPatientId implements IReturn<GetPatientDrugsByPatientIdResponse>, IGet
{
    /** @description The id of the patient to retrieve patient drugs for */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve patient drugs for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetPatientDrugsByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientDrugsByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientDrugsByPatientIdResponse(); }
}

// @Route("/drug-management-api/patient-drugs/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPatientDrugs implements IReturn<SetPatientDrugsResponse>, IPost
{
    /** @description The patient drug form data to save */
    // @ApiMember(DataType="model", Description="The patient drug form data to save", IsRequired=true, Name="PatientDrugs", ParameterType="body")
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPatientDrugs'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPatientDrugsResponse(); }
}

export class GetPharmacistsByInstCode implements IReturn<GetPharmacistsByInstCodeResponse>, IGet
{
    public instCode: string;

    public constructor(init?: Partial<GetPharmacistsByInstCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacistsByInstCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacistsByInstCodeResponse(); }
}

export class GetPharmacistById implements IReturn<GetPharmacistByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetPharmacistById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacistById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacistByIdResponse(); }
}

// @Route("/drug-management-api/pharmacies", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacies implements IReturn<GetPharmaciesResponse>, IGet
{

    public constructor(init?: Partial<GetPharmacies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmaciesResponse(); }
}

// @Route("/drug-management-api/pharmacy/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyById implements IReturn<GetPharmacyByIdResponse>, IGet
{
    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPharmacyById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyByIdResponse(); }
}

// @Route("/drug-management-api/pharmacy/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyByInstitutionCode implements IReturn<GetPharmacyByInstitutionCodeResponse>, IGet
{
    /** @description The institution code of the pharmacy */
    // @ApiMember(DataType="string", Description="The institution code of the pharmacy", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetPharmacyByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyByInstitutionCodeResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyBatchesDrugRemainingByBatchIds implements IReturn<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>, IGet
{
    public batchIds: number[];
    public includeExhaustedBatches?: boolean;

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyBatchesDrugRemainingByBatchIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyBatchesDrugRemainingByBatchIdsResponse(); }
}

// @Route("/drug-management-api/pharmacy/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPharmacy implements IReturn<SetPharmacyResponse>, IPost
{
    /** @description The pharmacy form data to save */
    // @ApiMember(DataType="model", Description="The pharmacy form data to save", IsRequired=true, Name="PharmacyForm", ParameterType="body")
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacy>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPharmacy'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPharmacyResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyStock implements IReturn<QuarantinePharmacyStockResponse>, IPost
{
    /** @description The pharmacy id to quarantine */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    public constructor(init?: Partial<QuarantinePharmacyStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyStock'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyStockResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-depot-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyDepotBatch implements IReturn<QuarantinePharmacyDepotBatchResponse>, IPost
{
    /** @description The pharmacy depot batch ids to quarantine */
    // @ApiMember(DataType="integer[]", Description="The pharmacy depot batch ids to quarantine", IsRequired=true, Name="Ids", ParameterType="body")
    public ids: number[];

    public constructor(init?: Partial<QuarantinePharmacyDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyDepotBatchResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-quarantined-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ActionQuarantinedStock implements IReturn<ActionQuarantinedStockResponse>, IPost
{
    /** @description The pharmacy id to quarantine */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    /** @description The action to take on the pharmacy's stock */
    // @ApiMember(DataType="integer", Description="The action to take on the pharmacy's stock", IsRequired=true, Name="QuarantinedStockAction", ParameterType="body")
    public quarantinedStockAction: QuarantinedStockAction;

    public constructor(init?: Partial<ActionQuarantinedStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionQuarantinedStock'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActionQuarantinedStockResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-depot-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantineRemovePharmacyDepotBatch implements IReturn<QuarantineRemovePharmacyDepotBatchResponse>, IPost
{
    /** @description The pharmacy id related to these depot batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these depot batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description A dictionary of the depot batch ids correlating to the new state of the unit count */
    // @ApiMember(DataType="dictionary", Description="A dictionary of the depot batch ids correlating to the new state of the unit count", IsRequired=true, Name="DepotBatchStates", ParameterType="body")
    public depotBatchStates: { [index: number]: QuarantinedStockAction; };

    public constructor(init?: Partial<QuarantineRemovePharmacyDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantineRemovePharmacyDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantineRemovePharmacyDepotBatchResponse(); }
}

// @Route("/drug-management-api/pharmacy/emails", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyEmails implements IReturn<GetPharmacyEmailsResponse>, IGet
{
    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The institution code of the pharmacy */
    // @ApiMember(DataType="string", Description="The institution code of the pharmacy", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetPharmacyEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyEmails'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyEmailsResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyBatches implements IReturn<QuarantinePharmacyBatchesResponse>, IPost
{
    /** @description The pharmacy id related to these batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description The batch ids and amounts to quarantine at the pharmacy */
    // @ApiMember(DataType="array", Description="The batch ids and amounts to quarantine at the pharmacy", IsRequired=true, Name="BatchAmounts", ParameterType="body")
    public batchAmounts: BatchAmount[];

    public constructor(init?: Partial<QuarantinePharmacyBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyBatches'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyBatchesResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-quarantined-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ActionQuarantinedPharmacyBatches implements IReturn<ActionQuarantinedPharmacyBatchesResponse>, IPost
{
    /** @description The pharmacy id related to these batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description A dictionary of the batch ids correlating to the new state of the unit count */
    // @ApiMember(DataType="model", Description="A dictionary of the batch ids correlating to the new state of the unit count", IsRequired=true, Name="BatchActions", ParameterType="body")
    public batchActions: { [index: number]: QuarantinedStockAction; };

    /** @description The date of destruction of destroyed batches. */
    // @ApiMember(DataType="DateTime", Description="The date of destruction of destroyed batches.", Name="Destruction Date", ParameterType="body")
    public destructionDate?: string;

    /** @description Notes pertaining to destroyed batches. */
    // @ApiMember(DataType="false", Description="Notes pertaining to destroyed batches.", IsRequired=true, Name="Notes", ParameterType="body")
    public notes: string;

    public constructor(init?: Partial<ActionQuarantinedPharmacyBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionQuarantinedPharmacyBatches'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActionQuarantinedPharmacyBatchesResponse(); }
}

// @Route("/drug-management-api/timepoints", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepoints implements IReturn<GetTimepointsResponse>
{

    public constructor(init?: Partial<GetTimepoints>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTimepoints'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTimepointsResponse(); }
}

// @Route("/drug-management-api/timepoints/treatment/{TreatmentId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepointsByTreatmentId implements IReturn<GetTimepointsResponse>
{
    /** @description The treatment id to get timepoints for */
    // @ApiMember(DataType="int", Description="The treatment id to get timepoints for", IsRequired=true, Name="TreatmentId", ParameterType="path")
    public treatmentId: number;

    public constructor(init?: Partial<GetTimepointsByTreatmentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTimepointsByTreatmentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTimepointsResponse(); }
}

// @Route("/invoice-management-api/exports", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceExports implements IReturn<GetInvoiceExportsResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceExports>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExports'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceExportsResponse(); }
}

// @Route("/invoice-management-api/exports/metadata", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class GetInvoiceExportsMetadata implements IReturn<GetInvoiceExportsMetadataResponse>, IGet
{
    /** @description The end date of the range of invoices exported */
    // @DataMember
    // @ApiMember(DataType="DateTime", Description="The end date of the range of invoices exported", Name="InvoiceEndDate", ParameterType="path")
    public invoiceEndDate?: string;

    public constructor(init?: Partial<GetInvoiceExportsMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportsMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceExportsMetadataResponse(); }
}

// @Route("/invoice-management-api/exports/{InvoiceExportId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceExportById implements IReturn<GetInvoiceExportByIdResponse>, IGet
{
    /** @description The ID of the invoice export */
    // @ApiMember(DataType="int", Description="The ID of the invoice export", Name="InvoiceExportId", ParameterType="path")
    public invoiceExportId?: number;

    public constructor(init?: Partial<GetInvoiceExportById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceExportByIdResponse(); }
}

// @Route("/invoice-management-api/exports/{InvoiceExportId}/download", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DownloadInvoiceExport implements IReturn<Blob>, IGet
{
    /** @description The ID of the invoice export */
    // @ApiMember(DataType="int", Description="The ID of the invoice export", Name="InvoiceExportId", ParameterType="path")
    public invoiceExportId: number;

    public constructor(init?: Partial<DownloadInvoiceExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadInvoiceExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/invoice-management-api/exports/new", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
// @DataContract
export class PostCreateInvoiceExport implements IReturn<PostCreateExportResponse>, IPost
{
    /** @description The end date of the range of invoices exported */
    // @DataMember
    // @ApiMember(DataType="DateTime", Description="The end date of the range of invoices exported", Name="InvoiceEndDate", ParameterType="path")
    public invoiceEndDate?: string;

    public constructor(init?: Partial<PostCreateInvoiceExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateInvoiceExport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCreateExportResponse(); }
}

// @Route("/invoice-management-api/requisitions", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceRequisitions implements IReturn<GetInvoiceRequisitionsResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceRequisitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceRequisitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceRequisitionsResponse(); }
}

// @Route("/invoice-management-api/requisitions/{InstCode}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceRequisitionsByInstitutionCode implements IReturn<GetInvoiceRequisitionsByInstitutionCodeResponse>, IGet
{
    /** @description The unique institution code */
    // @ApiMember(DataType="string", Description="The unique institution code", Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetInvoiceRequisitionsByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceRequisitionsByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceRequisitionsByInstitutionCodeResponse(); }
}

// @Route("/invoice-management-api/requisition/{RequisitionId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceRequisitionById implements IReturn<GetInvoiceRequisitionByIdResponse>, IGet
{
    /** @description The ID of the invoice requisition */
    // @ApiMember(DataType="int", Description="The ID of the invoice requisition", IsRequired=true, Name="RequisitionId", ParameterType="path")
    public requisitionId: number;

    public constructor(init?: Partial<GetInvoiceRequisitionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceRequisitionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceRequisitionByIdResponse(); }
}

// @Route("/invoice-management-api/requisitions/metadata", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceRequisitionMetadata implements IReturn<GetInvoiceRequisitionMetadataResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceRequisitionMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceRequisitionMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceRequisitionMetadataResponse(); }
}

// @Route("/invoice-management-api/requisitions/new", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostCreateInvoiceRequisition implements IReturn<PostCreateInvoiceRequisitionResponse>, IPost
{
    /** @description The code of the target institution */
    // @ApiMember(DataType="string", Description="The code of the target institution", IsRequired=true, Name="InstCode", ParameterType="body")
    public instCode: string;

    public constructor(init?: Partial<PostCreateInvoiceRequisition>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCreateInvoiceRequisition'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCreateInvoiceRequisitionResponse(); }
}

// @Route("/invoice-management-api/requisition/{RequisitionId}/approve", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class PostApproveInvoiceRequisition implements IReturn<PostApproveInvoiceRequisitionResponse>, IPost
{
    /** @description The ID of the invoice requisition */
    // @ApiMember(DataType="int", Description="The ID of the invoice requisition", IsRequired=true, Name="RequisitionId", ParameterType="path")
    public requisitionId: number;

    /** @description The receipt number */
    // @ApiMember(DataType="string", Description="The receipt number", IsRequired=true, Name="ReceiptNumber", ParameterType="body")
    public receiptNumber: string;

    /** @description The date of the requisition approval */
    // @ApiMember(DataType="DateTime", Description="The date of the requisition approval", IsRequired=true, Name="DateOfApproval", ParameterType="body")
    public dateOfApproval: string;

    public constructor(init?: Partial<PostApproveInvoiceRequisition>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostApproveInvoiceRequisition'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostApproveInvoiceRequisitionResponse(); }
}

// @Route("/invoice-management-api/invoices", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoices implements IReturn<GetInvoicesResponse>, IGet
{
    /** @description The id of the patient */
    // @ApiMember(DataType="int", Description="The id of the patient", Name="PatientId", ParameterType="path")
    public patientId?: number;

    public constructor(init?: Partial<GetInvoices>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoices'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoicesResponse(); }
}

// @Route("/invoice-management-api/query/invoices", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QueryInvoices implements IReturn<QueryInvoicesResponse>, IGet
{
    /** @description The ID of the target patient */
    // @ApiMember(DataType="int", Description="The ID of the target patient", Name="PatientId", ParameterType="query")
    public patientId?: number;

    /** @description The status of the invoice */
    // @ApiMember(DataType="int", Description="The status of the invoice", Name="Status", ParameterType="query")
    public status?: InvoiceStatus;

    /** @description The date invoices were approved from */
    // @ApiMember(DataType="string", Description="The date invoices were approved from", Name="FromDateOfApproval", ParameterType="query")
    public fromDateOfApproval?: string;

    /** @description The date invoices were approved to */
    // @ApiMember(DataType="string", Description="The date invoices were approved to", Name="ToDateOfApproval", ParameterType="query")
    public toDateOfApproval?: string;

    public constructor(init?: Partial<QueryInvoices>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryInvoices'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryInvoicesResponse(); }
}

// @Route("/invoice-management-api/invoice/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceById implements IReturn<GetInvoiceByIdResponse>, IGet
{
    /** @description The id of the invoice */
    // @ApiMember(DataType="int", Description="The id of the invoice", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetInvoiceById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceByIdResponse(); }
}

// @Route("/invoice-management-api/invoice/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SaveInvoice implements IReturn<SaveInvoiceResponse>, IPost
{
    /** @description The invoice data to save */
    // @ApiMember(DataType="Invoice", Description="The invoice data to save", IsRequired=true, Name="Invoice", ParameterType="body")
    public invoice: Invoice;

    public constructor(init?: Partial<SaveInvoice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveInvoice'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveInvoiceResponse(); }
}

// @Route("/invoice-management-api/invoice/set-status", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetInvoiceStatus implements IReturn<SetInvoiceStatusResponse>, IPost
{
    /** @description The id of the invoice to set the status of */
    // @ApiMember(DataType="int", Description="The id of the invoice to set the status of", IsRequired=true, Name="InvoiceId", ParameterType="body")
    public invoiceId: number;

    /** @description The invoice status to set */
    // @ApiMember(DataType="InvoiceStatus", Description="The invoice status to set", IsRequired=true, Name="InvoiceStatus", ParameterType="body")
    public invoiceStatus: InvoiceStatus;

    /** @description The reason for rejection */
    // @ApiMember(DataType="Reason", Description="The reason for rejection", IsRequired=true, Name="Reason", ParameterType="body")
    public reason: string;

    public constructor(init?: Partial<SetInvoiceStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetInvoiceStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetInvoiceStatusResponse(); }
}

// @Route("/invoice-management-api/invoice/delete", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteInvoice implements IReturn<DeleteInvoiceResponse>, IPost
{
    /** @description The invoice id to delete */
    // @ApiMember(DataType="int", Description="The invoice id to delete", IsRequired=true, Name="InvoiceId", ParameterType="body")
    public invoiceId: number;

    public constructor(init?: Partial<DeleteInvoice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteInvoice'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteInvoiceResponse(); }
}

// @Route("/invoice-management-api/invoice-types", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceTypes implements IReturn<GetInvoiceTypesResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceTypesResponse(); }
}

// @Route("/invoice-management-api/invoice-types-with-reimbursement", "GET")
export class GetInvoiceTypesWithReimbursements implements IReturn<GetInvoiceTypesResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceTypesWithReimbursements>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceTypesWithReimbursements'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceTypesResponse(); }
}

// @Route("/invoice-management-api/invoice-lookups", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetInvoiceLookups implements IReturn<GetInvoiceLookupsResponse>, IGet
{

    public constructor(init?: Partial<GetInvoiceLookups>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceLookups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceLookupsResponse(); }
}

// @Route("/invoice-management-api/invoice/validate", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateInvoice implements IReturn<ValidateInvoiceResponse>, IPost
{
    /** @description The invoice form data to validate */
    // @ApiMember(DataType="Invoice", Description="The invoice form data to validate", IsRequired=true, Name="Invoice", ParameterType="body")
    public invoice: Invoice;

    public constructor(init?: Partial<ValidateInvoice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInvoice'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateInvoiceResponse(); }
}

// @Route("/invoice-management-api/invoice/file/download/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class DownloadInvoiceFile implements IReturn<Blob>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DownloadInvoiceFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadInvoiceFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/invoice-management-api/invoice/file/view/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInvoiceFile implements IReturn<Blob>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetInvoiceFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @Route("/opms/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{

    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    public guid: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    public guid: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    public guid: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    public guid: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/user")
export class GetUser implements IReturn<GetUserResponse>, IGet
{

    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

// @Route("/opms/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/opms/form-names")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{

    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/opms/event-definition/single/id/{Id}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleById implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleById
{
    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/single/code/{Code}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleByCode implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleByCode
{
    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<EventDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/collection", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetCollection implements IReturn<EventDefinitionCollectionResponse>, IEventDefinitionGetCollection
{

    public constructor(init?: Partial<EventDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionCollectionResponse(); }
}

// @Route("/opms/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleById
{
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleByCode
{
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IFormDefinitionGetCollection
{

    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/opms/patient-state/single/id/{Id}", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetSingleById implements IReturn<PatientStateSingleResponse>, IPatientStateGetSingleById
{
    /** @description The ID of the patient state to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientStateGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateSingleResponse(); }
}

// @Route("/opms/patient-state/collection", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetCollection implements IReturn<PatientStateCollectionResponse>, IPatientStateGetCollection
{

    public constructor(init?: Partial<PatientStateGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateCollectionResponse(); }
}

// @Route("/opms/treatment/single/id/{Id}", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetSingleById implements IReturn<TreatmentSingleResponse>, ITreatmentGetSingleById
{
    /** @description The ID of the treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentSingleResponse(); }
}

// @Route("/opms/treatment/collection", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetCollection implements IReturn<TreatmentCollectionResponse>, ITreatmentGetCollection
{

    public constructor(init?: Partial<TreatmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentCollectionResponse(); }
}

// @Route("/opms/master-group/single/id/{Id}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleById implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleById
{
    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/single/code/{Code}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByCode implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleByCode
{
    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<MasterGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/collection", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollection implements IReturn<MasterGroupCollectionResponse>, IMasterGroupGetCollection
{

    public constructor(init?: Partial<MasterGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/single/id/{Id}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleById implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleById
{
    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CollaboratingGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/single/code/{Code}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleByCode implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleByCode
{
    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CollaboratingGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/collection", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollection implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollection
{

    public constructor(init?: Partial<CollaboratingGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupId implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupId
{
    /** @description The ID of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupCode implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupCode
{
    /** @description The Code of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/country/single/id/{Id}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleById implements IReturn<CountrySingleResponse>, ICountryGetSingleById
{
    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/single/code/{Code}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByCode implements IReturn<CountrySingleResponse>, ICountryGetSingleByCode
{
    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CountryGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/collection", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollection implements IReturn<CountryCollectionResponse>, ICountryGetCollection
{

    public constructor(init?: Partial<CountryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupId
{
    /** @description The ID of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupCode
{
    /** @description The Code of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupId
{
    /** @description The ID of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupCode
{
    /** @description The Code of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/institution/single/id/{Id}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleById
{
    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/single/code/{Code}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByCode implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleByCode
{
    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<InstitutionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/collection", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollection
{

    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/id/{CountryId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryId
{
    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupId
{
    /** @description The ID of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupId
{
    /** @description The ID of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryCode
{
    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupCode
{
    /** @description The Code of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupCode
{
    /** @description The Code of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/patient/single/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IPatientGetSingleById
{
    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/single/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber
{
    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/validation/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationById implements IReturn<PatientValidationResponse>, IPatientGetValidationById
{
    /** @description The ID of the patient to validate. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/validation/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationByStudyNumber implements IReturn<PatientValidationResponse>, IPatientGetValidationByStudyNumber
{
    /** @description The Study Number of the patient to validate. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<PatientGetValidationByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/collection", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IPatientGetCollection
{
    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupId
{
    /** @description The ID of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupId
{
    /** @description The ID of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/id/{CountryId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryId
{
    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/id/{InstitutionId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionId
{
    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupCode
{
    /** @description The Code of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupCode
{
    /** @description The Code of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryCode
{
    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/code/{InstitutionCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionCode
{
    /** @description The Code of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/Save", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSave implements IReturn<PatientSingleResponse>
{
    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    public constructor(init?: Partial<PatientPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/ids", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithIds implements IReturn<PatientSingleResponse>
{
    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    public constructor(init?: Partial<PatientPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/codes", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithCodes implements IReturn<PatientSingleResponse>
{
    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    public constructor(init?: Partial<PatientPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/event/single/id/{Id}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleById implements IReturn<EventSingleResponse>, IEventGetSingleById
{
    /** @description The ID of the event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/ids", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByIds implements IReturn<EventSingleResponse>, IEventGetSingleByIds
{
    /** @description The Patient ID of the event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Id of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/codes", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByCodes implements IReturn<EventSingleResponse>, IEventGetSingleByCodes
{
    /** @description The Patient Study Number of the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Code of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/collection", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollection implements IReturn<EventCollectionResponse>, IEventGetCollection
{

    public constructor(init?: Partial<EventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/id/{PatientId}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientId implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientId
{
    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    public constructor(init?: Partial<EventGetCollectionByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/study-number/{PatientStudyNumber}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientStudyNumber implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientStudyNumber
{
    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    public constructor(init?: Partial<EventGetCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/Save", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSave implements IReturn<EventSingleResponse>
{
    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    public constructor(init?: Partial<EventPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/ids", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithIds implements IReturn<EventSingleResponse>
{
    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The ID of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/codes", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithCodes implements IReturn<EventSingleResponse>
{
    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The Code of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/form/source-document/single/id/{Id}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleById implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleById
{
    /** @description The ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/single/ids", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleByIds implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleByIds
{
    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the source document to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document if no source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/single/codes", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleByCodes implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleByCodes
{
    /** @description The Patient Study Number of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the source document to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document if no source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/collection", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollection implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollection
{

    public constructor(init?: Partial<SourceDocumentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollectionByIds implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollectionByIds
{
    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollectionByCodes implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollectionByCodes
{
    /** @description The Patient Study Number of the patient associated with the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/save", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSave implements IReturn<SourceDocumentSingleResponse>
{
    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/save/ids", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSaveWithIds implements IReturn<SourceDocumentSingleResponse>
{
    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The ID of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/save/codes", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSaveWithCodes implements IReturn<SourceDocumentSingleResponse>
{
    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The Code of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/delete", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDelete implements IReturn<SourceDocumentDeleteResponse>
{
    /** @description The source document to delete. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteWithId implements IReturn<SourceDocumentDeleteResponse>
{
    /** @description The ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/ids", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteWithIds implements IReturn<SourceDocumentDeleteResponse>
{
    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/codes", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteByCodes implements IReturn<SourceDocumentDeleteResponse>
{
    /** @description The Patient Study Number of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/validate", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidate implements IReturn<SourceDocumentValidationResponse>
{
    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/source-document/validate/ids", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidateWithIds implements IReturn<SourceDocumentValidationResponse>
{
    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The ID of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/source-document/validate/codes", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidateWithCodes implements IReturn<SourceDocumentValidationResponse>
{
    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The Code of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/finance-milestone/single/id/{Id}", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetSingleById implements IReturn<FinanceMilestoneSingleResponse>, IFormGetSingleById
{
    /** @description The ID of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FinanceMilestoneGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/single/ids", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetSingleByIds implements IReturn<FinanceMilestoneSingleResponse>, IFormGetSingleByIds
{
    /** @description The Patient ID of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new finance milestone if no finance milestone is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<FinanceMilestoneGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/single/codes", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetSingleByCodes implements IReturn<FinanceMilestoneSingleResponse>, IFormGetSingleByCodes
{
    /** @description The Patient Study Number of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new finance milestone if no finance milestone is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<FinanceMilestoneGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/collection", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetCollection implements IReturn<FinanceMilestoneCollectionResponse>, IFormGetCollection
{

    public constructor(init?: Partial<FinanceMilestoneGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneCollectionResponse(); }
}

// @Route("/opms/form/finance-milestone/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetCollectionByIds implements IReturn<FinanceMilestoneCollectionResponse>, IFormGetCollectionByIds
{
    /** @description The Patient ID of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<FinanceMilestoneGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneCollectionResponse(); }
}

// @Route("/opms/form/finance-milestone/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneCollectionResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneGetCollectionByCodes implements IReturn<FinanceMilestoneCollectionResponse>, IFormGetCollectionByCodes
{
    /** @description The Patient Study Number of the patient associated with the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<FinanceMilestoneGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinanceMilestoneCollectionResponse(); }
}

// @Route("/opms/form/finance-milestone/save", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostSave implements IReturn<FinanceMilestoneSingleResponse>
{
    /** @description The finance milestone to save. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    public constructor(init?: Partial<FinanceMilestonePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/save/ids", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostSaveWithIds implements IReturn<FinanceMilestoneSingleResponse>
{
    /** @description The finance milestone to save. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    /** @description The ID of the Institution associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<FinanceMilestonePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/save/codes", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneSingleResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostSaveWithCodes implements IReturn<FinanceMilestoneSingleResponse>
{
    /** @description The finance milestone to save. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    /** @description The Code of the Institution associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<FinanceMilestonePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneSingleResponse(); }
}

// @Route("/opms/form/finance-milestone/delete", "DELETE")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneDelete implements IReturn<FinanceMilestoneDeleteResponse>
{
    /** @description The finance milestone to delete. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    public constructor(init?: Partial<FinanceMilestoneDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FinanceMilestoneDeleteResponse(); }
}

// @Route("/opms/form/finance-milestone/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneDeleteWithId implements IReturn<FinanceMilestoneDeleteResponse>
{
    /** @description The ID of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FinanceMilestoneDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FinanceMilestoneDeleteResponse(); }
}

// @Route("/opms/form/finance-milestone/delete/ids", "DELETE")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneDeleteWithIds implements IReturn<FinanceMilestoneDeleteResponse>
{
    /** @description The Patient ID of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<FinanceMilestoneDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FinanceMilestoneDeleteResponse(); }
}

// @Route("/opms/form/finance-milestone/delete/codes", "DELETE")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneDeleteResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestoneDeleteByCodes implements IReturn<FinanceMilestoneDeleteResponse>
{
    /** @description The Patient Study Number of the finance milestone to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<FinanceMilestoneDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FinanceMilestoneDeleteResponse(); }
}

// @Route("/opms/form/finance-milestone/validate", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostValidate implements IReturn<FinanceMilestoneValidationResponse>
{
    /** @description The finance milestone to validate. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    public constructor(init?: Partial<FinanceMilestonePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneValidationResponse(); }
}

// @Route("/opms/form/finance-milestone/validate/ids", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostValidateWithIds implements IReturn<FinanceMilestoneValidationResponse>
{
    /** @description The finance milestone to validate. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    /** @description The ID of the Institution associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<FinanceMilestonePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneValidationResponse(); }
}

// @Route("/opms/form/finance-milestone/validate/codes", "POST")
// @Api(Description="Form - Finance Milestone")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FinanceMilestoneValidationResponse)", StatusCode=500)
// @DataContract
export class FinanceMilestonePostValidateWithCodes implements IReturn<FinanceMilestoneValidationResponse>
{
    /** @description The finance milestone to validate. */
    // @DataMember(Order=1)
    public form: FinanceMilestone;

    /** @description The Code of the Institution associated with the finance milestone to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the finance milestone to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the finance milestone to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the finance milestone to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<FinanceMilestonePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestonePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneValidationResponse(); }
}

// @Route("/opms/form/registration/single/id/{Id}", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetSingleById implements IReturn<RegistrationSingleResponse>, IFormGetSingleById
{
    /** @description The ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/single/ids", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetSingleByIds implements IReturn<RegistrationSingleResponse>, IFormGetSingleByIds
{
    /** @description The Patient ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the registration to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration if no registration is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/single/codes", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetSingleByCodes implements IReturn<RegistrationSingleResponse>, IFormGetSingleByCodes
{
    /** @description The Patient Study Number of the registration to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the registration to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration if no registration is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/collection", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetCollection implements IReturn<RegistrationCollectionResponse>, IFormGetCollection
{

    public constructor(init?: Partial<RegistrationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCollectionResponse(); }
}

// @Route("/opms/form/registration/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetCollectionByIds implements IReturn<RegistrationCollectionResponse>, IFormGetCollectionByIds
{
    /** @description The Patient ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCollectionResponse(); }
}

// @Route("/opms/form/registration/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetCollectionByCodes implements IReturn<RegistrationCollectionResponse>, IFormGetCollectionByCodes
{
    /** @description The Patient Study Number of the patient associated with the registration to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCollectionResponse(); }
}

// @Route("/opms/form/registration/save", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostSave implements IReturn<RegistrationSingleResponse>
{
    /** @description The registration to save. */
    // @DataMember(Order=1)
    public form: Registration;

    public constructor(init?: Partial<RegistrationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/save/ids", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostSaveWithIds implements IReturn<RegistrationSingleResponse>
{
    /** @description The registration to save. */
    // @DataMember(Order=1)
    public form: Registration;

    /** @description The ID of the Institution associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/save/codes", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostSaveWithCodes implements IReturn<RegistrationSingleResponse>
{
    /** @description The registration to save. */
    // @DataMember(Order=1)
    public form: Registration;

    /** @description The Code of the Institution associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/opms/form/registration/delete", "DELETE")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationDelete implements IReturn<RegistrationDeleteResponse>
{
    /** @description The registration to delete. */
    // @DataMember(Order=1)
    public form: Registration;

    public constructor(init?: Partial<RegistrationDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationDeleteResponse(); }
}

// @Route("/opms/form/registration/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationDeleteWithId implements IReturn<RegistrationDeleteResponse>
{
    /** @description The ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationDeleteResponse(); }
}

// @Route("/opms/form/registration/delete/ids", "DELETE")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationDeleteWithIds implements IReturn<RegistrationDeleteResponse>
{
    /** @description The Patient ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationDeleteResponse(); }
}

// @Route("/opms/form/registration/delete/codes", "DELETE")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationDeleteByCodes implements IReturn<RegistrationDeleteResponse>
{
    /** @description The Patient Study Number of the registration to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationDeleteResponse(); }
}

// @Route("/opms/form/registration/validate", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostValidate implements IReturn<RegistrationValidationResponse>
{
    /** @description The registration to validate. */
    // @DataMember(Order=1)
    public form: Registration;

    public constructor(init?: Partial<RegistrationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationValidationResponse(); }
}

// @Route("/opms/form/registration/validate/ids", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostValidateWithIds implements IReturn<RegistrationValidationResponse>
{
    /** @description The registration to validate. */
    // @DataMember(Order=1)
    public form: Registration;

    /** @description The ID of the Institution associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationValidationResponse(); }
}

// @Route("/opms/form/registration/validate/codes", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostValidateWithCodes implements IReturn<RegistrationValidationResponse>
{
    /** @description The registration to validate. */
    // @DataMember(Order=1)
    public form: Registration;

    /** @description The Code of the Institution associated with the registration to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationValidationResponse(); }
}

// @Route("/opms/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download-all/{PatientId}/{FormDefinitionId}/{FormId}", "GET")
export class DownloadAllFiles implements IReturn<Blob>, IGet
{
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;

    public constructor(init?: Partial<DownloadAllFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAllFiles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/event-state/id/{Id}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesById implements IReturn<EventStateResponse>, IPatientGetEventStatesById
{
    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventStatesById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/event-state/study-number/{StudyNumber}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesByStudyNumber implements IReturn<EventStateResponse>, IPatientGetEventStatesByStudyNumber
{
    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<EventStatesByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/form-state/ids/{Id}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=500)
// @DataContract
export class FormStatesByIds implements IReturn<FormStateResponse>, IPatientGetFormStatesByIds
{
    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description The event definition ID of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The event repeat of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    public constructor(init?: Partial<FormStatesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormStatesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormStateResponse(); }
}

export class PostHasOpmsPermissionsByIds implements IReturn<HasOpmsPermissionCollectionResponse>
{
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public patientId?: number;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class PostHasOpmsPermissionsByCodes implements IReturn<HasOpmsPermissionCollectionResponse>
{
    public masterGroupCode: string;
    public coordinatingGroupCode: string;
    public institutionCode: string;
    public patientStudyNumber: string;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class GetInstitutionPersonnel implements IReturn<InstitutionPersonnelResponse>, IGet
{
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelResponse(); }
}

export class GetInstitutionPersonnelNames implements IReturn<InstitutionPersonnelNamesResponse>, IGet
{
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelNames>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelNames'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelNamesResponse(); }
}

export class GetTrialPersonnelHasActiveRole implements IReturn<TrialPersonnelActiveRoleResponse>, IGet
{
    public personId: number;
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetTrialPersonnelHasActiveRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelHasActiveRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialPersonnelActiveRoleResponse(); }
}

